// frontend/src/components/GrowthWorkspace.jsx
// Version: 3.0 (quick-260916-wll — офисы из держателя, литералы канона убраны)
//
// 🔴 ЧТО УБРАНО 17.09.2026 — ПЯТАЯ КОПИЯ КАНОНА. Здесь лежал массив офисов
//    «по умолчанию»: боевые UUID профилей, адреса, телефон, имя адвоката и
//    ссылки на карты. Живые данные лишь НАКРЫВАЛИ этот массив сверху —
//    разворачиванием объекта с запасным значением на каждое поле.
//    ЛИТЕРАЛ БЫЛ ОСНОВОЙ карточки: любое поле, которого нет в ответе, молча
//    показывалось из вёрстки, и отличить на экране «пришло с сервера» от
//    «написано здесь» было НЕЛЬЗЯ. Тот же дефект, что подстановка в `catch`,
//    только без `catch` — и потому ещё незаметнее.
//    Третий офис в этом массиве НЕ СУЩЕСТВУЕТ ВООБЩЕ (подтверждено владельцем).
//
// 🔴 ОТКУДА ОФИСЫ ТЕПЕРЬ: ручка `GET /api/v1/ofisy/` — единственный держатель
//    (`backend/app/services/ofisy.py`), форма ответа `{ofisy, vsego}`.
//    В карточку идёт `adres_naruzhu`, а не `adres_vnutri`, и вот почему: с
//    этих карточек открывается пульт GMB, то есть карточка ВЕДЁТ К ПУБЛИКАЦИИ
//    на площадке Google. ЧТО ИМЕННО можно опубликовать, решает канон поофисно
//    через `ulica_publichna`, и вид адреса обязан быть тем, который канон
//    разрешает наружу, — каковы бы ни были признаки сегодня. Молчаливое
//    допущение в любую сторону — дефект.
//
// 🔴 ОТКАЗ ДЕРЖАТЕЛЯ (503) И ПУСТОЙ СПИСОК — РАЗНЫЕ СОСТОЯНИЯ МИРА, и на
//    экране они выглядят по-разному. Слить их значит сказать «офисов нет»
//    там, где их не смогли прочитать.
// Description: Центр роста и репутации практики Fitenko Law PLLC: Marketing Pulse,
//              Reputation & Public Trust, Citations, Office Profiles.
//
// 🔴 ЧТО УБРАНО 15.09.2026. Экран показывал ИЗМЕРЕНИЯ, которых никто не делал:
//    конверсии по каналам («calls: 72, paid: 34, conversion: 47.2»), кривые
//    лидов за 30 и 90 дней, сводку «138 обращений · 62 записи · 44,9 % · пайплайн
//    $21 700», AI Health 99 из 100, «1 из 72 сигналов», «99,2 % · +0,7 %»,
//    точность NAP по офисам и число отзывов в Google. Ни одно из этих чисел
//    ниоткуда не бралось — они были НАПИСАНЫ.
//
// 🔴 ХУЖЕ ЧИСЕЛ БЫЛИ ОБЕЩАНИЯ ДЕЙСТВИЙ. «Run Full Audit» крутил таймер и
//    рапортовал о завершённой проверке 72 сигналов, не обратившись ни к одной
//    ручке. «Execute Automated Fix» сообщал, что схема выкачена в JSON-LD
//    главной страницы сайта, ничего никуда не выкатив. Возврат из Google OAuth
//    печатал «подключено», НЕ СПРОСИВ, подключено ли.
//    Прежние формулировки здесь НЕ ЦИТИРУЮТСЯ дословно: их стережёт
//    `__tests__/vydumannaya-faktura.test.js`.
//    Сообщение об исходе, написанное до исхода, — не сообщение
//    ([[knowledge_promise_is_not_a_gate]]).
//
// 🔴 ЧЕМ ЗАМЕНЕНО: честное «источника нет» на месте каждого числа и ФАКТИЧЕСКИЙ
//    исход ручки на месте заранее написанного успеха. Ручек бэкенда эта задача
//    не изобретает: где источника нет, там и написано, что его нет.
//
// 🔴 ЧТО ПОЛУЧИЛО ЖИВОЙ ИСТОЧНИК 16.09.2026 (quick-260916-udw): ЧЕТЫРЕ карточки
//    верхнего ряда вкладки «Reputation & Trust» — `nap-i-citaty`, `open-issues`,
//    `entity-status`, `nap-baseline`. Они читают готовый отчёт
//    `GET /api/v1/reputation/full-audit/latest` и показывают ТОЛЬКО то, что в нём
//    есть: индекс NAP со своим знаменателем, цитаты нейросетей со своим,
//    длину и разбивку `prescriptions`, число канонических локаций, а также
//    метод, момент и возраст замера.
//
// 🔴 ЧТО ИЗМЕНИЛОСЬ 17.09.2026 (quick-260917-28c). Прежняя строка выше
//    утверждала, что метод, момент и возраст стоят НА КАЖДОЙ из четырёх
//    карточек. Это было правдой и было дефектом: один и тот же технический
//    блок («метод / момент / возраст записи: NNNN с») повторялся четырежды и
//    читался как вывод отладочного журнала. Подпись НЕ УБРАНА — она сведена в
//    ОДНУ плашку `[data-podpis-zamera]` над рядом и переведена в человеческий
//    вид, оставшись при этом СВЕРЯЕМОЙ: точный момент из ответа лежит в
//    `dateTime`/`title`, точные секунды — в `data-vozrast-sek`. Человек читает
//    пересказ, проверяющий — исходное значение; ни одно из двух не потеряно.
//
// 🔴 ЧТО ПОЛУЧИЛО ИЗОБРАЖЕНИЕ И ПО КАКОМУ ПРАВИЛУ (там же, 17.09.2026). У
//    четырёх величин верхнего ряда появились полосы, и НИ ОДНОЙ НОВОЙ ВЕЛИЧИНЫ
//    при этом не заведено: ни дат, ни кривых «за 30 дней», ни стрелок роста.
//    Ширина каждой полосы ВЫЧИСЛЯЕТСЯ из числа ответа — другой отчёт даёт
//    другую ширину; записанная руками ширина запрещена, потому что расходится
//    с величиной молча.
//    🔴 ОГРАНИЧЕНИЕ 0..100 ОТНОСИТСЯ К ПОЛОСЕ И НИКОГДА К ЧИСЛУ. Пришло 140 —
//    человек видит 140, полоса упирается в 100, и расхождение НАЗВАНО подписью:
//    молча ограниченная полоса рядом с числом 140 читалась бы как «так и надо».
//    🔴 Три исхода арифметики различимы ПОРОЗНЬ: «величины в ответе нет»,
//    «делить не на что» и «измеренный ноль» — разные положения дел, и слить их
//    значило бы сказать «измерено и вышло ноль» там, где измерения не было.
//
// 🔴 ЧЕГО ЗДЕСЬ ВСЁ ЕЩЁ НЕТ (названо вслух, чтобы не считалось сделанным):
//    живого источника НЕТ у всего остального на этом экране — у Marketing Pulse,
//    у блока офисов, у журнала проверок и у кривых спроса. Прежнее утверждение
//    «источника нет ни для одной цифры» после этой правки ЛОЖНО для четырёх
//    названных карточек и остаётся ИСТИННЫМ для остальных блоков.
//
// 🔴 ЧЕГО НЕ ПОЯВИЛОСЬ: сводного «скора репутации» (отчёт не содержит его
//    НАРОЧНО — `full_audit_orchestrator.py:548-552`) и второй точки платного
//    запуска: `POST /full-audit/run` на этом экране ровно один — внутри
//    `FullAuditModal`, за его собственными воротами.

import React, { useState, useMemo, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import {
  TrendingUp,
  ShieldCheck,
  Award,
  MapPin,
  PhoneCall,
  MessageSquare,
  Users,
  Search,
  ExternalLink,
  CheckCircle2,
  AlertTriangle,
  Play,
  Sparkles,
  Globe,
  Sliders,
  ChevronRight,
  Info,
  Swords,
  FileText,
  BarChart3,
  Building,
  Zap,
  Bot,
  Mail,
  Plus
} from 'lucide-react';
import { GmbCommandModal } from './reputation/GmbCommandModal';
import CitationsWorklist from './reputation/CitationsWorklist';
import DirectoriesTable from './reputation/DirectoriesTable';
import { GmbPostsTab } from './reputation/GmbPostsTab';
import GrowthOpportunitiesTab from './reputation/GrowthOpportunitiesTab';
import FullAuditModal from './reputation/FullAuditModal';
import { OfficeVisibilityBlock, formatEdtDateTime } from './reputation/OfficeVisibilityBlock';
import { OfficeCompactCard } from './reputation/OfficeCompactCard';
import { fetchGeogridData } from '../services/geogridCache';
import reputationService from '../services/reputationService';
import {
  Card,
  Button,
  Badge
} from './ui';
import { formatBookedConsultsReason } from '../utils/pluralize';
import { useUiLanguage, perevesti, sklonit as sklonitHelper } from '../context/UiLanguageContext';
import { useBranding } from '../context/BrandingContext';

// 🔴 ЕДИНАЯ НАДПИСЬ ТАМ, ГДЕ ЖИВОГО ИСТОЧНИКА НЕТ. Одна на весь экран: два
// разных текста об одном и том же читаются как два разных положения дел.
const ISTOCHNIKA_NET = 'Источника нет: эта величина не измеряется — ручки, которая бы её выдала, не существует.';
const ISTOCHNIKA_NET_RU = ISTOCHNIKA_NET;
const ISTOCHNIKA_NET_EN = 'No source: this metric is not measured — no API endpoint exists to provide it.';
const NET_CHISLA = '—';

// Каналы привлечения. 🔴 ОСТАЛИСЬ ТОЛЬКО НАЗВАНИЯ: числа звонков, оплат и
// конверсии («calls: 72, paid: 34, conversion: 47.2») были написаны руками и
// показывались как замер, а короткие «insight» — как вывод из этого замера.
const KANALY = [
  { id: 'voice', name: 'AI Voice (Sofia)', icon: PhoneCall },
  { id: 'maps', name: 'Google Maps', icon: MapPin },
  { id: 'referrals', name: 'Referrals & Attorney Network', icon: Users },
  { id: 'chat', name: 'Website Chat (Katifi)', icon: MessageSquare }
];

// 🔴 СПИСОК СПРАВОЧНИКОВ БОЛЬШЕ НЕ ЗАШИТ В ФАЙЛ. Здесь стояли три записи
// Google Business Profile с адресами офисов (в том числе НЕСУЩЕСТВУЮЩЕГО) и
// ссылками на карты, и запись реестра Florida Bar с именем адвоката и номером.
//
// Записи GMB теперь строятся из ответа держателя офисов — по одной на КАЖДЫЙ
// офис канона, и ни одной сверх.
//
// 🔴 ЗАПИСЬ РЕЕСТРА FLORIDA BAR УБРАНА, А НЕ ПЕРЕНЕСЕНА, И ЭТО НАЗВАНО ВСЛУХ:
// имя адвоката и номер допуска — канон, но ДЕРЖАТЕЛЯ этого канона в коде НЕТ
// (в `ofisy.json` таких полей нет по построению). Правило: канон берётся у
// держателя или не берётся вовсе; вторая копия расходится с оригиналом молча.
// Завести держателя реестровых сведений — отдельная работа с владельцем, она
// записана в отложенное, а не выдана за сделанную.

// 🔴 МЕТОД, МОМЕНТ И ВОЗРАСТ ЗАМЕРА — ОДИН РАЗ НА ВЕСЬ РЯД (ПРАВИЛО НОЛЬ §4:
// число без указания, чем и когда оно получено, читается как текущее).
// Возраст берётся ТОЛЬКО у сервера (`cache_age_seconds` считается в момент
// ответа, `full_audit_orchestrator.py:301-303`): свой второй счёт по часам
// браузера разошёлся бы с первым молча.

/**
 * Человеческий вид момента по часам UTC. 🔴 Собирается ДЕТЕРМИНИРОВАННО из
 * частей (`getUTC*`), а НЕ `toLocaleString`: локаль и пояс браузера сделали бы
 * показанное несравнимым с тем, что лежит в ответе. Часы НАЗВАНЫ подписью
 * `UTC` — дефект, который в бэкенде лечили полями `snapshot_clock`/`snapshot_tz`
 * (`full_audit_orchestrator.py:363-376`), был не в расхождении часов, а в
 * отсутствии подписи, по каким часам взята дата.
 * 🔴 Не привелось к дате — возвращается `null`, и наверх уходит ИСХОДНАЯ строка:
 * `Invalid Date` на экране выглядел бы как дата, которой никто не получал.
 */
const chelovecheskijMomentUTC = (syroj) => {
  if (typeof syroj !== 'string' || !syroj) return null;
  const d = new Date(syroj);
  if (Number.isNaN(d.getTime())) return null;
  const dv = (n) => String(n).padStart(2, '0');
  return `${dv(d.getUTCDate())}.${dv(d.getUTCMonth() + 1)}.${d.getUTCFullYear()}, `
    + `${dv(d.getUTCHours())}:${dv(d.getUTCMinutes())} UTC`;
};

/**
 * Человеческое округление возраста записи. Точное значение НЕ теряется: оно
 * остаётся на узле в `title` и `data-vozrast-sek`, поэтому показанное можно
 * сверить с ответом. Тильда обязательна — округлённое не выдаётся за точное.
 */
const chelovecheskijVozrast = (sek, t, lang) => {
  if (typeof sek !== 'number' || !Number.isFinite(sek)) return null;
  const drob = (x) => Number(x).toLocaleString(lang === 'en' ? 'en-US' : 'ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  if (sek < 60) return t('rep.podpis.time_s', { n: Math.round(sek) });
  if (sek < 3600) return t('rep.podpis.time_m', { n: Math.round(sek / 60) });
  if (sek < 86400) return t('rep.podpis.time_h', { n: drob(sek / 3600) });
  return t('rep.podpis.time_d', { n: drob(sek / 86400) });
};

const PodpisZameraEdinaya = ({ otvet, nap, lang, t }) => {
  if (!otvet) return null;
  const metod = nap && nap.measured_method === 'human_screenshot'
    ? t('rep.podpis.method_human_screenshots')
    : t('rep.podpis.method_not_stated');
  const momentSyroj = (otvet.storage === 'tenant_file'
    ? (otvet.cache_written_at || otvet.completed_at)
    : otvet.completed_at) || t('rep.podpis.timestamp_not_stated');
  const momentChelovechnyj = chelovecheskijMomentUTC(momentSyroj);
  const vozrast = chelovecheskijVozrast(otvet.cache_age_seconds, t, lang);
  return (
    <div
      data-podpis-zamera="1"
      className="bg-white border border-border rounded-2xl px-5 py-3 shadow-xs text-xs text-text-muted leading-relaxed flex flex-wrap items-center gap-x-2 gap-y-1"
    >
      <Info className="w-3.5 h-3.5 text-accent shrink-0" />
      <span className="text-text">{t('rep.podpis.audit_recorded')}</span>
      {momentChelovechnyj ? (
        <time
          dateTime={momentSyroj}
          title={momentSyroj}
          className="text-text font-semibold"
        >
          {momentChelovechnyj}
        </time>
      ) : (
        <span className="text-text">
          <span className="font-semibold">{momentSyroj}</span>
          {' '}
          <span className="text-text-muted">
            {t('rep.podpis.invalid_date')}
          </span>
        </span>
      )}
      <span className="text-border">·</span>
      <span>{t('rep.podpis.method', { method: metod })}</span>
      <span className="text-border">·</span>
      {vozrast ? (
        <span
          data-vozrast-sek={otvet.cache_age_seconds}
          title={t('rep.podpis.cache_age_title', { seconds: otvet.cache_age_seconds })}
        >
          {t('rep.podpis.cache_updated_ago', { age: vozrast })}
        </span>
      ) : (
        <span>{t('rep.podpis.in_process_only')}</span>
      )}
    </div>
  );
};

// ── АРИФМЕТИКА ШКАЛ: ОДИН помощник на все индикаторы ─────────────────────────
// 🔴 ПОЧЕМУ ОДИН. Второй счёт той же доли разошёлся бы с первым МОЛЧА, и на
//    экране оказались бы две величины, называющие себя одним именем.
//
// 🔴 ПОЧЕМУ ВОЗВРАЩАЕТСЯ ИСХОД, А НЕ ЧИСЛО. Исходов три, и к числу они не
//    сводятся: «величины нет», «делить не на что» и «измеренный ноль» — разные
//    положения дел, и слить их значило бы сказать «измерено и вышло ноль» там,
//    где измерения не было. Различие обязано доехать до экрана целым.
//
// 🔴 `chislo` И `shirina` — РАЗНЫЕ ПОЛЯ НАРОЧНО. Ограничение 0..100 относится к
//    ИЗОБРАЖЕНИЮ полосы и НИКОГДА к печатаемому числу: `chislo` уходит наверх
//    ровно тем, чем пришло с сервера. Подменить печатаемое подогнанным значит
//    спрятать поломку прибора ровно там, где человек мог бы её заметить.
const SHKALA_MAX = 100;

const dolyaDlyaShkaly = (velichina, delitel) => {
  if (!Number.isFinite(velichina)) return { vid: 'net', prichina: 'net-velichiny' };
  const estDelitel = delitel !== undefined;
  if (estDelitel && (!Number.isFinite(delitel) || delitel === 0)) {
    return { vid: 'net', prichina: 'net-znamenatelya' };
  }
  const dolya = estDelitel ? (velichina / delitel) * 100 : velichina;
  // Округляется ТОЛЬКО доля для ширины: десятая доля процента полосы не видна,
  // а печатаемое число не округляется вовсе.
  const okruglennaya = Math.round(dolya * 10) / 10;
  let shirina = okruglennaya;
  let vneShkaly = null;
  if (okruglennaya > SHKALA_MAX) {
    shirina = SHKALA_MAX;
    vneShkaly = 'verh';
  } else if (okruglennaya < 0) {
    shirina = 0;
    vneShkaly = 'niz';
  }
  return {
    vid: 'est',
    chislo: velichina,
    dolya: okruglennaya,
    shirina,
    vneShkaly,
    nolIzmeren: okruglennaya === 0,
  };
};

// Подписи исхода «полосы нет»: причины РАЗНЫЕ, и текст у них разный.
const podpisNetShkaly = (prichina, t) => {
  if (prichina === 'net-velichiny') {
    return t('rep.bar.no_value');
  }
  if (prichina === 'net-znamenatelya') {
    return t('rep.bar.no_denominator');
  }
  return null;
};

/**
 * Полоса индикатора. 🔴 Ширина ВЫЧИСЛЯЕТСЯ инлайновым стилем из величины
 * ответа. Записанная руками ширина — что в стиле, что классом Tailwind —
 * запрещена: она разойдётся с величиной молча, и первым это увидит клиент.
 * 🔴 Образцы запрещённых написаний здесь НЕ ЦИТИРУЮТСЯ дословно нарочно: их
 * ищет по файлу поиск-прибор ворот, и дословная цитата в прозе даёт ему
 * ложное красное — прибор не отличает пример от дефекта.
 * Исход `net` — заполнителя НЕТ ВООБЩЕ: пустая полоса рядом с прочерком
 * читалась бы как измеренный ноль.
 */
const Polosa = ({ itog, imya, t: propT }) => {
  const { lang: rawLang, t: contextT } = useUiLanguage();
  const t = propT || (rawLang ? contextT : (k, v) => perevesti('ru', k, v));
  if (!itog) return null;
  if (itog.vid === 'net') {
    return (
      <div className="flex items-baseline gap-1.5 text-[10px] text-text-muted leading-relaxed">
        <span className="text-sm text-text">{NET_CHISLA}</span>
        <span>{podpisNetShkaly(itog.prichina, t)}</span>
      </div>
    );
  }
  return (
    <div className="space-y-1">
      <div className="h-1.5 w-full bg-surface-sunken rounded-full overflow-hidden">
        <div
          data-shkala={imya}
          data-vne-shkaly={itog.vneShkaly || undefined}
          data-nol-izmeren={itog.nolIzmeren ? '1' : undefined}
          style={{ width: `${itog.shirina}%` }}
          className={`h-full rounded-full ${itog.vneShkaly ? 'bg-warning' : 'bg-accent'}`}
        />
      </div>
      {itog.nolIzmeren && (
        <div className="text-[10px] text-text-muted leading-relaxed">{t('rep.bar.measured_zero')}</div>
      )}
      {itog.vneShkaly === 'verh' && (
        <div className="text-[10px] text-warning leading-relaxed">
          {t('rep.bar.over_100')}
        </div>
      )}
      {itog.vneShkaly === 'niz' && (
        <div className="text-[10px] text-warning leading-relaxed">
          {t('rep.bar.under_0')}
        </div>
      )}
    </div>
  );
};

// ── Шаги подключения офиса (Пустое состояние вместо выключенных кнопок) ──────
const OfficeConnectionSteps = ({ office, gmbAuthStatus, onCreateProfile, onConnectGoogle, isCreating, t }) => {
  const hasProfile = Boolean(office.profileId);
  const isGoogleConnected = Boolean(gmbAuthStatus?.connected || gmbAuthStatus?.has_gmb_scope);
  const hasPlaceId = Boolean(office.place_id);

  if (hasProfile && isGoogleConnected && hasPlaceId) {
    return null;
  }

  return (
    <div className="mt-3 p-3 bg-surface border border-border rounded-xl space-y-2 text-xs">
      {/* Шаг 1: Профиль в системе */}
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className={`w-4 h-4 rounded-full flex items-center justify-center text-[10px] font-bold ${
            hasProfile ? 'bg-success-soft text-success' : 'bg-accent-soft text-accent-ink border border-accent-border'
          }`}>
            {hasProfile ? '✓' : '1'}
          </span>
          <span className={hasProfile ? 'text-success font-medium' : 'text-text font-medium'}>
            {hasProfile ? (office.company_name || 'Profile') : t('rep.office.step_no_profile')}
          </span>
        </div>
        {!hasProfile && (
          <button
            onClick={() => onCreateProfile(office)}
            disabled={isCreating}
            className="h-7 px-2.5 inline-flex items-center gap-1 text-[11px] font-semibold rounded-lg bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50 transition-colors shadow-2xs cursor-pointer"
          >
            <Plus className="w-3 h-3 text-accent" />
            <span>{isCreating ? t('rep.office.creating_profile') : t('rep.office.btn_create_profile')}</span>
          </button>
        )}
      </div>

      {/* Шаг 2: Google подключён */}
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className={`w-4 h-4 rounded-full flex items-center justify-center text-[10px] font-bold ${
            isGoogleConnected ? 'bg-success-soft text-success' : 'bg-accent-soft text-accent-ink border border-accent-border'
          }`}>
            {isGoogleConnected ? '✓' : '2'}
          </span>
          <span className={isGoogleConnected ? 'text-success font-medium' : 'text-text-muted'}>
            {isGoogleConnected ? (gmbAuthStatus?.email || 'Google Connected') : t('rep.office.step_no_google')}
          </span>
        </div>
        {!isGoogleConnected && (
          <div className="flex flex-col items-end gap-1">
            <button
              onClick={onConnectGoogle}
              className="h-7 px-2.5 inline-flex items-center gap-1 text-[11px] font-semibold rounded-lg bg-surface-raised border border-border text-text hover:bg-surface transition-colors shadow-2xs cursor-pointer"
            >
              {t('rep.office.btn_connect_google')}
            </button>
            <span className="text-[10px] text-text-muted text-right max-w-[280px]">
              {t('rep.office.google_account_hint')}
            </span>
          </div>
        )}
      </div>

      {/* Шаг 3: Связь листинга (place_id) */}
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className={`w-4 h-4 rounded-full flex items-center justify-center text-[10px] font-bold ${
            hasPlaceId ? 'bg-success-soft text-success' : 'bg-surface-sunken text-text-muted'
          }`}>
            {hasPlaceId ? '✓' : '3'}
          </span>
          <span className={hasPlaceId ? 'text-success font-medium' : 'text-text-muted'}>
            {hasPlaceId ? `Listing ID: ${office.place_id}` : t('rep.office.step_no_place_id')}
          </span>
        </div>
      </div>
    </div>
  );
};

const PUSTYE_PROFILI = [];

export const GrowthWorkspace = ({
  profiles: propProfiles = PUSTYE_PROFILI,
  stats = {},
  ofisy: propOfisy,
  onOpenSourceOfTruth,
  onOpenAgentBattle,
  onOpenAnalytics,
  onImproveLocation,
  onProfilesChange
}) => {
  const [createdProfiles, setCreatedProfiles] = useState([]);
  const profiles = useMemo(() => {
    const bazovye = Array.isArray(propProfiles) ? propProfiles : [];
    if (createdProfiles.length === 0) return bazovye;
    const knownIds = new Set(bazovye.map((p) => p.id).filter(Boolean));
    return [...bazovye, ...createdProfiles.filter((p) => !knownIds.has(p.id))];
  }, [propProfiles, createdProfiles]);
  const { lang: rawLang, t: contextT, sklonit: contextSklonit } = useUiLanguage();
  const { branding, isFitenko } = useBranding();
  const tenant = branding?.instance_name || (isFitenko ? 'fitenko' : 'eln');
  const lang = rawLang || 'ru';
  const t = useCallback((k, v) => (rawLang ? contextT(k, v) : perevesti('ru', k, v)), [rawLang, contextT]);
  // Словарь на отсутствующий ключ отдаёт «[ключ]» (truthy), поэтому `t(k) || x`
  // запасного не даёт никогда. Каналы приходят из features/<tenant>.json с id,
  // которых в словаре может не быть, — показываем название, а не ключ.
  const tIliZapasnoe = useCallback((k, v, zapasnoe) => {
    const s = t(k, v);
    return s === `[${k}]` ? zapasnoe : s;
  }, [t]);
  const sklonit = useCallback((k, c, v) => (rawLang ? contextSklonit(k, c, v) : sklonitHelper('ru', k, c, v)), [rawLang, contextSklonit]);
  const [activeTab, setActiveTab] = useState(() => {
    try {
      if (typeof window !== 'undefined' && window.location && window.location.search) {
        const sp = new URLSearchParams(window.location.search);
        const tVal = sp.get('tab');
        if (tVal === 'gmb_posts' || tVal === 'posts') return 'gmb_posts';
        if (['marketing', 'reputation', 'citations', 'locations', 'opportunities'].includes(tVal)) return tVal;
      }
    } catch (_) {}
    return 'reputation';
  });

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.location && window.location.search) {
        const sp = new URLSearchParams(window.location.search);
        const tVal = sp.get('tab');
        if (tVal === 'gmb_posts' || tVal === 'posts') {
          setActiveTab('gmb_posts');
        }
      }
    } catch (_) {}
  }, []);
  const [timeframe, setTimeframe] = useState('30d'); // '30d' | '90d'
  const [metricType, setMetricType] = useState('leads'); // 'leads' | 'booked' | 'organic'
  const [selectedGmbOffice, setSelectedGmbOffice] = useState(null);
  const [isGmbModalOpen, setIsGmbModalOpen] = useState(false);
  const [gmbAuthStatus, setGmbAuthStatus] = useState({ connected: false, has_gmb_scope: false });

  // ── Marketing Pulse: живые обращения из базы Fitenko OS ──────────────────
  const [pulseData, setPulseData] = useState(null);
  const [pulseLoading, setPulseLoading] = useState(false);
  const [pulseError, setPulseError] = useState(null);

  const fetchMarketingPulse = useCallback(async () => {
    setPulseLoading(true);
    try {
      const res = await axios.get(`/api/v1/reputation/marketing-pulse?timeframe=${timeframe}`);
      setPulseData(res.data || null);
      setPulseError(null);
    } catch (err) {
      setPulseData(null);
      setPulseError(
        (err && err.response && err.response.data && err.response.data.detail)
        || (err && err.message)
        || t('rep.error.db_read')
      );
    } finally {
      setPulseLoading(false);
    }
  }, [timeframe, t]);

  useEffect(() => {
    fetchMarketingPulse();
  }, [fetchMarketingPulse]);

  // ── Google Search Console (Organic Reach) ─────────────────────────────────
  const [gscData, setGscData] = useState(null);
  const [gscLoading, setGscLoading] = useState(false);
  const [gscError, setGscError] = useState(null);

  const fetchGscSummary = useCallback(async () => {
    setGscLoading(true);
    try {
      const res = await axios.get(`/api/v1/reputation/gsc/summary?timeframe=${timeframe}`);
      setGscData(res.data || null);
      setGscError(null);
    } catch (err) {
      setGscData(null);
      setGscError(
        (err && err.response && err.response.data && err.response.data.detail)
        || (err && err.message)
        || t('rep.state.no_source')
      );
    } finally {
      setGscLoading(false);
    }
  }, [tenant, timeframe, t]);

  useEffect(() => {
    fetchGscSummary();
  }, [fetchGscSummary]);

  // ── Офисы арендатора: ЕДИНСТВЕННЫЙ ДЕРЖАТЕЛЬ `GET /api/v1/ofisy/` ─────────
  // 🔴 ТРИ ВЕЛИЧИНЫ, А НЕ ОДНА. `ofisy === null` — ещё не спрашивали или
  //    спросить не удалось; `ofisy === []` — спросили, и офисов у арендатора
  //    НЕТ (законный ответ: у mlg файла канона нет и быть не должно);
  //    `ofisyOtkaz` — держатель ОТКАЗАЛ (503, канон не прочитан). Свести
  //    отказ и пустоту в одно состояние значит сказать «офисов нет» там, где
  //    их не смогли прочитать.
  const [ofisy, setOfisy] = useState(() => (Array.isArray(propOfisy) ? propOfisy : null));
  const [ofisyOtkaz, setOfisyOtkaz] = useState(null);
  const [ofisyZagruzka, setOfisyZagruzka] = useState(() => propOfisy === undefined);

  useEffect(() => {
    if (propOfisy !== undefined) {
      setOfisy(Array.isArray(propOfisy) ? propOfisy : []);
      setOfisyZagruzka(false);
      return;
    }
    let zhiv = true;
    axios.get('/api/v1/ofisy/')
      .then((res) => {
        if (!zhiv) return;
        setOfisy(Array.isArray(res.data?.ofisy) ? res.data.ofisy : []);
        setOfisyOtkaz(null);
      })
      .catch((err) => {
        if (!zhiv) return;
        setOfisy(null);
        setOfisyOtkaz(
          (err && err.response && err.response.data && err.response.data.detail)
          || (err && err.message)
          || t('rep.error.reason_not_specified')
        );
      })
      .finally(() => { if (zhiv) setOfisyZagruzka(false); });
    return () => { zhiv = false; };
  }, [propOfisy, t]);

  // ── Последний ЗАВЕРШЁННЫЙ замер: `GET /full-audit/latest` ─────────────────
  // 🔴 Три величины, а не одна: отказ САМОГО запроса (сеть, 401) — это НЕ
  // «замеров не было», и свалить их в одно состояние значит потерять различие.
  const [otchetOtvet, setOtchetOtvet] = useState(null);
  const [zagruzka, setZagruzka] = useState(true);
  const [otkazZaprosa, setOtkazZaprosa] = useState(null);

  const zaprositPosledniy = useCallback(async () => {
    setZagruzka(true);
    try {
      const res = await axios.get('/api/v1/reputation/full-audit/latest');
      setOtchetOtvet(res.data || null);
      setOtkazZaprosa(null);
    } catch (err) {
      setOtchetOtvet(null);
      setOtkazZaprosa((err && err.message) || t('rep.error.reason_not_specified'));
    } finally {
      setZagruzka(false);
    }
  }, [t]);

  useEffect(() => {
    // 🔴 Только GET. Ни одного платного прогона отсюда не уходит.
    zaprositPosledniy();
  }, [zaprositPosledniy]);

  useEffect(() => {
    // Check if redirected from Google OAuth callback
    const params = new URLSearchParams(window.location.search);
    const googleAuth = params.get('google_auth');
    if (googleAuth === 'success') {
      // 🔴 Раньше здесь печаталось «успешно подключен! …авторизован для прямой
      //    публикации», причём с адресом почты — БЕЗ ЕДИНОЙ ПРОВЕРКИ. Признак
      //    `google_auth=success` приходит СТРОКОЙ В АДРЕСЕ и говорит лишь о том,
      //    что нас вернули; подключено ли и с каким правом — знает ручка
      //    состояния. Спрашиваем ЕЁ и говорим то, что ответила она.
      window.history.replaceState({}, document.title, window.location.pathname);
      axios.get('/api/v1/reputation/gmb/auth/status')
        .then((res) => {
          const sostoyanie = res.data || {};
          setGmbAuthStatus(sostoyanie);
          if (sostoyanie.connected && sostoyanie.has_gmb_scope) {
            toast.success(
              t('rep.auth.connected_verified'),
              { duration: 7000 }
            );
          } else if (sostoyanie.connected) {
            toast(
              t('rep.auth.connected_no_scope'),
              { icon: '⚠️', duration: 7000 }
            );
          } else {
            toast.error(
              t('rep.auth.not_confirmed'),
              { duration: 7000 }
            );
          }
        })
        .catch((err) => {
          toast.error(
            t('rep.auth.verify_failed', { error: (err && err.message) || t('rep.error.reason_not_specified') }),
            { duration: 7000 }
          );
        });
    } else if (googleAuth === 'error') {
      const detail = params.get('detail') || t('rep.auth.incomplete');
      toast.error(t('rep.auth.error_detail', { detail }), { duration: 6000 });
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    const checkGmbAuth = async () => {
      try {
        const res = await axios.get('/api/v1/reputation/gmb/auth/status');
        if (res.data) {
          setGmbAuthStatus(res.data);
        }
      } catch (err) {
        console.warn('Failed to fetch GMB auth status:', err);
      }
    };
    checkGmbAuth();
  }, [t]);


  // Главный профиль для быстрых переходов.
  // 🔴 ЗДЕСЬ БЫЛ ЗАШИТ БОЕВОЙ UUID и, в хвосте `||`, ЦЕЛЫЙ ВЫДУМАННЫЙ ОБЪЕКТ
  //    профиля с адресом и ссылкой на карты: кнопки открывали окна с профилем,
  //    которого в системе может не быть вовсе. Нет профиля — `null`, и кнопки
  //    выключаются с честной подписью.
  const mainProfile = useMemo(() => {
    return profiles.find(p => p.is_main) || profiles[0] || null;
  }, [profiles]);

  const netProfilya = t('rep.office.no_profiles');

  const [creatingProfileKluch, setCreatingProfileKluch] = useState(null);

  const handleCreateProfileFromOffice = async (office) => {
    if (!office || creatingProfileKluch) return;
    setCreatingProfileKluch(office.kluch);
    try {
      // POST /profiles строго с полями из канона офиса (eln.json / ofisy)
      const payload = {
        company_name: office.company_name || office.nazvanie,
        company_url: office.sayt || '',
        address: office.address || '',
        location_name: office.location_name || '',
        contact_phone: office.phone || '',
        contact_email: office.pochta || '',
        is_main: !!office.is_main,
      };
      const res = await axios.post('/api/v1/reputation/profiles', payload);
      if (res.data) {
        setCreatedProfiles((prev) => [...prev, res.data]);
      }
      try {
        const listRes = await axios.get('/api/v1/reputation/profiles');
        if (Array.isArray(listRes.data)) {
          setCreatedProfiles(listRes.data);
        }
      } catch (e) {
        // silent
      }
      if (onProfilesChange) onProfilesChange();
      toast.success(t('rep.office.create_profile_success'));
    } catch (err) {
      console.error('Failed to create profile from office canon:', err);
      const prichina = err.response?.data?.detail || err.message || t('rep.error.reason_not_specified');
      toast.error(t('rep.office.create_profile_error', { error: prichina }), { duration: 6000 });
    } finally {
      setCreatingProfileKluch(null);
    }
  };

  const handleConnectGoogle = async () => {
    try {
      const res = await axios.get('/api/v1/reputation/gmb/auth/url');
      const authUrl = res.data?.authorization_url || res.data?.auth_url;
      if (authUrl) {
        window.open(authUrl, '_blank');
      } else {
        const prichina = res.data?.detail || t('rep.error.reason_not_specified');
        toast.error(t('rep.office.connect_google_error', { error: prichina }), { duration: 6000 });
      }
    } catch (err) {
      console.error('Failed to get Google auth URL:', err);
      const prichina = err.response?.data?.detail || err.message || t('rep.error.reason_not_specified');
      toast.error(t('rep.office.connect_google_error', { error: prichina }), { duration: 6000 });
    }
  };

  // ── Карточки офисов: КАНОН ДЕРЖАТЕЛЯ, а не литерал ───────────────────────
  // 🔴 Литерал больше не является основой карточки: если держатель не ответил,
  //    карточек НЕТ ВООБЩЕ, а не «есть, но из вёрстки».
  // 🔴 Держатель офисов и список профилей отвечают на РАЗНЫЕ вопросы: «где
  //    фирма сидит» против «какие профили заведены в системе». Поэтому офис
  //    рисуется из канона, а идентификатор для перехода в пульт GMB берётся
  //    ТОЛЬКО из `profiles`; совпадения нет — переход недоступен, и это честно
  //    (у офиса канона нет UUID профиля по построению).
  // 🔴 Привязка: ЕДИНЫЙ держатель на бэкенде (_ofis_kanona отдаёт p.office_kluch).
  //    Сопоставление по городу на фронте устранено.
  const officeList = useMemo(() => {
    if (!ofisy) return [];
    return ofisy.map((o) => {
      const profil = profiles.find((p) => p.office_kluch === o.kluch || p.kluch === o.kluch) || null;
      return {
        kluch: o.kluch,
        nazvanie: o.nazvanie,
        company_name: o.firma,
        location_name: [o.gorod, o.shtat].filter(Boolean).join(', '),
        // 🔴 ПУБЛИЧНЫЙ вид адреса: с этой карточки открывается пульт GMB, то
        //    есть она ведёт к ПУБЛИКАЦИИ на площадке Google.
        address: o.adres_naruzhu,
        phone: o.telefon,
        sayt: o.sayt,
        pochta: o.pochta,
        place_id: o.place_id,
        is_main: !!o.glavnyy,
        badge: o.glavnyy ? t('rep.office.badge_main_canon') : t('rep.office.badge_branch'),
        profileId: profil ? profil.id : null,
        gmb_url: (profil && profil.gmb_url) || null,
      };
    });
  }, [ofisy, profiles, t]);

  const knownOfficePlaceIds = useMemo(() => {
    if (!ofisy || !Array.isArray(ofisy)) return [];
    return ofisy.map((o) => o.place_id).filter(Boolean);
  }, [ofisy]);

  // ── Выбранный офис для детального блока геосетки («список сверху, подробности снизу») ──
  const [selectedOfficeKluch, setSelectedOfficeKluch] = useState(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get('office') || '';
    } catch (e) {
      return '';
    }
  });

  // Синхронизация с officeList: fallback на главный офис, если параметр пуст или не найден
  useEffect(() => {
    if (!Array.isArray(officeList) || officeList.length === 0) return;

    const params = new URLSearchParams(window.location.search);
    const paramOffice = params.get('office');

    if (paramOffice && officeList.some((o) => o.kluch === paramOffice)) {
      if (selectedOfficeKluch !== paramOffice) {
        setSelectedOfficeKluch(paramOffice);
      }
    } else {
      const defaultOffice = officeList.find((o) => o.is_main) || officeList[0];
      if (defaultOffice && selectedOfficeKluch !== defaultOffice.kluch) {
        setSelectedOfficeKluch(defaultOffice.kluch);
      }
    }
  }, [officeList]);

  // Обработка перехода по истории браузера (Назад / Вперёд)
  useEffect(() => {
    const handlePopState = () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const paramOffice = params.get('office');
        if (paramOffice && officeList.some((o) => o.kluch === paramOffice)) {
          setSelectedOfficeKluch(paramOffice);
        } else if (officeList.length > 0) {
          const defaultOffice = officeList.find((o) => o.is_main) || officeList[0];
          setSelectedOfficeKluch(defaultOffice.kluch);
        }
      } catch (e) {
        // ignore
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [officeList]);

  const handleSelectOffice = useCallback((kluch) => {
    setSelectedOfficeKluch(kluch);
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('office', kluch);
      window.history.pushState({ office: kluch }, '', url.toString());
    } catch (e) {
      // ignore
    }
  }, []);

  const selectedOffice = useMemo(() => {
    if (!Array.isArray(officeList) || officeList.length === 0) return null;
    return (
      officeList.find((o) => o.kluch === selectedOfficeKluch) ||
      officeList.find((o) => o.is_main) ||
      officeList[0] ||
      null
    );
  }, [officeList, selectedOfficeKluch]);

  const renderOfficeActionButtons = (office) => {
    if (!office) return null;
    if (!office.profileId) {
      return (
        <div className="flex flex-wrap items-center gap-2">
          <button
            onClick={() => handleCreateProfileFromOffice(office)}
            disabled={creatingProfileKluch === office.kluch}
            className="h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50 transition-colors shadow-2xs cursor-pointer"
            title={t('rep.office.btn_create_profile')}
          >
            <Plus className="w-3 h-3 text-accent" />
            <span>{creatingProfileKluch === office.kluch ? t('rep.office.creating_profile') : t('rep.office.btn_create_profile')}</span>
          </button>
          {!gmbAuthStatus.has_gmb_scope && (
            <div className="inline-flex flex-col items-start gap-1">
              <button
                onClick={handleConnectGoogle}
                className="h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-surface-raised border border-border text-text hover:bg-surface transition-colors shadow-2xs cursor-pointer"
                title={t('rep.office.btn_connect_google')}
              >
                <span>{t('rep.office.btn_connect_google')}</span>
              </button>
              <span className="text-[10px] text-text-muted max-w-[320px]">
                {t('rep.office.google_account_hint')}
              </span>
            </div>
          )}
          {!office.place_id && (
            <span className="text-[11px] text-text-muted px-2 py-1 rounded bg-surface-sunken">
              {t('rep.office.step_no_place_id')}
            </span>
          )}
        </div>
      );
    }
    return (
      <div className="flex flex-wrap items-center gap-2">
        <button
          onClick={() => {
            if (!office.profileId) return;
            setSelectedGmbOffice({ ...office, id: office.profileId });
            setIsGmbModalOpen(true);
          }}
          disabled={!office.profileId}
          className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg transition-colors shadow-2xs ${
            !office.profileId
              ? 'bg-surface-sunken text-text-muted border border-border opacity-60 cursor-not-allowed'
              : gmbAuthStatus.has_gmb_scope
                ? 'bg-success-soft text-success border border-success hover:opacity-90 cursor-pointer'
                : 'bg-accent-soft text-accent-ink border border-accent-border hover:opacity-90 cursor-pointer'
          }`}
          title={office.profileId ? t('rep.office.gmb_console_title') : t('rep.office.unlinked_profile_notice')}
        >
          <Sparkles className="w-3 h-3 text-accent" />
          <span>GMB AI</span>
          {gmbAuthStatus.has_gmb_scope && (
            <span className="w-1.5 h-1.5 rounded-full bg-success inline-block ml-0.5" />
          )}
        </button>
        {office.gmb_url && (
          <a
            href={office.gmb_url}
            target="_blank"
            rel="noopener noreferrer"
            className="h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-surface-raised border border-border text-text hover:bg-surface transition-colors cursor-pointer shadow-2xs"
            title="Open Google Maps Listing"
          >
            <ExternalLink className="w-3 h-3 text-accent" />
            <span>GMB</span>
          </a>
        )}
        <button
          onClick={() => office.profileId && onOpenSourceOfTruth && onOpenSourceOfTruth({ ...office, id: office.profileId })}
          disabled={!office.profileId}
          className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-surface-raised border border-border text-text transition-colors shadow-2xs ${office.profileId ? 'hover:bg-surface cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
          title={office.profileId ? t('rep.office.truth_source_title') : t('rep.office.unlinked_profile_notice')}
        >
          <FileText className="w-3 h-3 text-text-muted" />
          <span>Truth</span>
        </button>
        <button
          onClick={() => office.profileId && onOpenAgentBattle && onOpenAgentBattle({ ...office, id: office.profileId })}
          disabled={!office.profileId}
          title={office.profileId ? t('rep.office.arena_title') : t('rep.office.unlinked_profile_notice')}
          className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg transition-colors shadow-2xs ${!office.profileId ? 'opacity-50 cursor-not-allowed ' : 'cursor-pointer '}${
            office.is_main
              ? 'bg-primary text-primary-foreground hover:opacity-90'
              : 'bg-accent-soft text-accent-ink border border-accent-border hover:opacity-90'
          }`}
        >
          <Swords className="w-3 h-3 text-accent" />
          <span>Arena</span>
        </button>
        <button
          onClick={() => office.profileId && onOpenAnalytics && onOpenAnalytics({ ...office, id: office.profileId })}
          disabled={!office.profileId}
          className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-surface-raised border border-border text-text transition-colors shadow-2xs ${office.profileId ? 'hover:bg-surface cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
          title={office.profileId ? t('rep.action.analytics') : t('rep.office.profile_not_linked')}
        >
          <BarChart3 className="w-3 h-3 text-text-muted" />
        </button>
      </div>
    );
  };

  // ── История замеров геосетки и данные для стратегического плана ──────────
  const [geogridHistory, setGeogridHistory] = useState([]);
  const [geogridHistoryLoading, setGeogridHistoryLoading] = useState(true);
  const [geogridRunsByKluch, setGeogridRunsByKluch] = useState({});

  useEffect(() => {
    let zhiv = true;
    if (!Array.isArray(ofisy) || ofisy.length === 0) {
      setGeogridHistory([]);
      setGeogridRunsByKluch({});
      setGeogridHistoryLoading(false);
      return;
    }

    setGeogridHistoryLoading(true);
    Promise.all(
      ofisy.map((o) =>
        fetchGeogridData(o.kluch)
          .then(({ geogrid: res }) => ({ kluch: o.kluch, ofis: o, data: res }))
          .catch(() => ({ kluch: o.kluch, ofis: o, data: null }))
      )
    )
      .then((results) => {
        if (!zhiv) return;
        const allRuns = [];
        const runsMap = {};

        results.forEach(({ kluch, ofis, data: res }) => {
          if (res?.status === 'measured') {
            if (res.payload) {
              runsMap[kluch] = res;
            }

            const rawRuns = (Array.isArray(res.history) && res.history.length > 0)
              ? res.history
              : (res.payload?.run ? [res.payload.run] : []);

            rawRuns.forEach((h) => {
              if (!h) return;

              // Охват по худшему запросу замера с указанием запроса
              let worstKw = null;
              let minCov = null;

              if (Array.isArray(h.keywords)) {
                h.keywords.forEach((kw) => {
                  const m = kw.metrics || kw;
                  const cov = typeof m.measurementCoverage === 'number'
                    ? m.measurementCoverage
                    : (typeof m.totalRequested === 'number' && typeof m.validObservationsCount === 'number' && m.totalRequested > 0
                        ? m.validObservationsCount / m.totalRequested
                        : null);

                  if (cov !== null) {
                    if (minCov === null || cov < minCov) {
                      minCov = cov;
                      worstKw = kw;
                    }
                  }
                });
              }

              let coverageStr = t('rep.state.not_measured');
              if (minCov !== null && worstKw) {
                const wm = worstKw.metrics || worstKw;
                const covVal = Math.round(minCov * 100);
                const validObs = typeof wm.validObservationsCount === 'number' ? wm.validObservationsCount : null;
                const totalPoints = typeof wm.totalRequested === 'number' ? wm.totalRequested : null;
                const pointsStr = (validObs !== null && totalPoints !== null)
                  ? t('rep.geogrid.points_count', { validObs, totalPoints })
                  : '';

                if (h.keywords && h.keywords.length > 1 && worstKw.keyword) {
                  coverageStr = t('rep.geogrid.worst_keyword', { covVal, pointsStr, keyword: worstKw.keyword });
                } else {
                  coverageStr = `${covVal}%${pointsStr}`;
                }
              }

              allRuns.push({
                runId: h.runId || null,
                officeNazvanie: ofis.nazvanie || h.displayName || kluch,
                startedAt: h.startedAt || (h === res.payload?.run ? res.received_at : null),
                keywordsCount: Array.isArray(h.keywords) ? h.keywords.length : 0,
                keywordsList: Array.isArray(h.keywords) ? h.keywords.map((k) => k.keyword || k) : [],
                keywordsSource: h.keywordsSource || null,
                keywordsSourceReason: h.keywordsSourceReason || null,
                c2Reputation: h.c2_reputation || (h === res.payload?.run ? res.c2_reputation : null),
                status: h.status
                  ? (h.status === 'SUCCESS' || h.status === 'COMPLETED' ? t('rep.audit_history.status_success') : h.status)
                  : t('rep.state.not_specified'),
                origin: h.origin || t('rep.state.not_specified'),
                provider: h.provider || t('rep.state.not_specified'),
                coverage: coverageStr,
              });
            });
          }
        });

        // Сортировка всей ленты по startedAt (самый свежий первый)
        allRuns.sort((a, b) => {
          const tA = a.startedAt ? new Date(a.startedAt).getTime() : 0;
          const tB = b.startedAt ? new Date(b.startedAt).getTime() : 0;
          return tB - tA;
        });

        setGeogridRunsByKluch(runsMap);
        setGeogridHistory(allRuns);
      })
      .finally(() => {
        if (zhiv) setGeogridHistoryLoading(false);
      });

    return () => { zhiv = false; };
  }, [ofisy, t]);

  const strategicPlan = useMemo(() => {
    const kluchi = Object.keys(geogridRunsByKluch);
    if (kluchi.length === 0) return null;

    let weakestItem = null;

    kluchi.forEach((kluch) => {
      const res = geogridRunsByKluch[kluch];
      const run = res?.payload?.run;
      const ofis = ofisy?.find((o) => o.kluch === kluch);
      const officeNazvanie = ofis?.nazvanie || run?.displayName || kluch;
      const ownPlaceId = res?.place_id || run?.target?.placeId;

      if (run && Array.isArray(run.keywords)) {
        run.keywords.forEach((kw) => {
          const m = kw.metrics;
          if (!m) return;

          // 🔴 ПРАВИЛО НОЛЬ §3: Запрос без доли в топ-3 не попадает в «самый слабый» (нельзя сравнивать то, что не измерено),
          // но и НЕ считается 100%. Если поля нет — пропускаем.
          if (typeof m.unweightedTop3Share !== 'number') {
            return;
          }

          const top3Share = m.unweightedTop3Share;
          const totalRequested = typeof m.totalRequested === 'number'
            ? m.totalRequested
            : (typeof run.grid?.rows === 'number' && typeof run.grid?.cols === 'number'
                ? run.grid.rows * run.grid.cols
                : null);

          const foundCount = typeof m.foundCount === 'number' ? m.foundCount : null;
          const notFoundCount = (foundCount !== null && totalRequested !== null)
            ? Math.max(0, totalRequested - foundCount)
            : null;

          const top10Share = typeof m.unweightedTop10Share === 'number' ? m.unweightedTop10Share : null;
          const top3Count = totalRequested !== null ? Math.round(top3Share * totalRequested) : null;
          const top10Count = (top10Share !== null && totalRequested !== null)
            ? Math.round(top10Share * totalRequested)
            : null;

          if (!weakestItem || top3Share < weakestItem.top3Share) {
            const obs = (res.payload?.observations || []).filter((o) => o.keyword === kw.keyword);
            const compCounts = {};
            obs.forEach((o) => {
              (o.topEntries || []).slice(0, 3).forEach((entry) => {
                if (entry.placeId && entry.placeId !== ownPlaceId && entry.title) {
                  if (!knownOfficePlaceIds.includes(entry.placeId)) {
                    compCounts[entry.title] = (compCounts[entry.title] || 0) + 1;
                  }
                }
              });
            });

            const topCompetitors = Object.entries(compCounts)
              .sort((a, b) => b[1] - a[1])
              .slice(0, 2)
              .map(([title]) => title);

            weakestItem = {
              kluch,
              officeNazvanie,
              keyword: kw.keyword,
              top3Share,
              top3Count,
              top10Share,
              top10Count,
              foundCount,
              notFoundCount,
              totalRequested,
              topCompetitors,
            };
          }
        });
      }
    });

    return weakestItem;
  }, [geogridRunsByKluch, ofisy, knownOfficePlaceIds]);

  /**
   * Состояние держателя офисов словами. 🔴 Три исхода и три РАЗНЫХ текста:
   * «ещё не спросили», «спросить не удалось» и «офисов нет». Совпади тексты —
   * «не смогли прочитать» читалось бы как «нет».
   */
  const SostoyanieOfisov = () => {
    if (ofisyZagruzka) {
      return (
        <p data-ofisy="zagruzka" className="text-xs text-text-muted leading-relaxed">
          {t('rep.sostoyanie_ofisov.loading')}
        </p>
      );
    }
    if (ofisyOtkaz) {
      return (
        <p data-ofisy="otkaz" className="text-xs text-text leading-relaxed">
          {t('rep.sostoyanie_ofisov.failed', { error: ofisyOtkaz })}
        </p>
      );
    }
    if (officeList.length === 0) {
      return (
        <p data-ofisy="pusto" className="text-xs text-text-muted leading-relaxed">
          {t('rep.sostoyanie_ofisov.empty')}
        </p>
      );
    }
    return null;
  };

  // Расчёт максимума для динамической шкалы SVG

  // Запуск live аудита.
  // 🔴 РАНЬШЕ ЭТО БЫЛА ИНСЦЕНИРОВКА: таймер накручивал проценты и через две
  //    секунды рапортовал о завершённой проверке 72 сигналов, не обратившись
  //    НИ К ОДНОЙ ручке. Отчёт о работе, которой не было, хуже отсутствия
  //    кнопки: по нему перестают проверять руками.
  // 🔴 Раньше здесь крутился таймер и рапортовал об успехе, ничего не проверив.
  //    Теперь кнопка открывает окно, которое запускает настоящий прогон на
  //    сервере и показывает ЕГО состояние: ни одной величины клиент не считает.
  // 🔴 ЗДЕСЬ НЕ ДОЛЖНО БЫТЬ ВЕТКИ «отдать нажатие наружу». Она тут была, и с
  //    16.09.2026 по 17.09.2026 главная кнопка на бою открывала СТАРОЕ окно
  //    (`AuditRunner`, аудит профиля через GPT-4o): страница передавала
  //    `onRunAudit`, ветка срабатывала первой, и до окна с воротами нажатие не
  //    доходило НИ РАЗУ. Нашли глазами; ни один стенд не покраснел, потому что
  //    каждый судил свой компонент, а «куда ведёт кнопка на собранной
  //    странице» не было утверждением ни об одном из них.
  //    Сторож маршрута: `__tests__/header-audit-button-route.test.js`.
  const handleTriggerAudit = () => {
    setAuditOpen(true);
  };

  const [auditOpen, setAuditOpen] = useState(false);

  // ── Разбор ответа `/latest` ───────────────────────────────────────────────
  const otchet = (otchetOtvet && otchetOtvet.report) ? otchetOtvet.report : null;
  const nap = otchet ? otchet.nap : null;
  const geoItogo = (otchet && otchet.geo && otchet.geo._itogo) ? otchet.geo._itogo : null;
  const predpisaniya = (otchet && Array.isArray(otchet.prescriptions)) ? otchet.prescriptions : null;
  const kritichnyh = predpisaniya ? predpisaniya.filter((p) => p && p.severity === 'critical').length : 0;
  const obychnyh = predpisaniya ? (predpisaniya.length - kritichnyh) : 0;

  // ── Шкалы верхнего ряда: считаются ОДНИМ помощником ──────────────────────
  // 🔴 Индекс NAP считается ОДИН раз и уходит в две карточки (`nap-i-citaty` и
  //    `nap-baseline`). Второй счёт той же величины разошёлся бы с первым молча,
  //    и на экране стояли бы два разных изображения одного числа.
  const shkalaNap = nap ? dolyaDlyaShkaly(nap.overall_score) : null;
  const shkalaCitat = geoItogo
    ? dolyaDlyaShkaly(geoItogo.our_citations_total, geoItogo.citations_total)
    : null;
  const shkalaPokrytiya = nap ? dolyaDlyaShkaly(nap.measured_count, nap.total_count) : null;

  // 🔴 Состояния без замера: тексты РАЗЛИЧАЮТСЯ дословно и не содержат ни
  // одного числа и ни одного процента — включая «0». Ноль на экране означал бы
  // измеренный ноль, а измерения здесь не было.
  const sostoyanieZamera = (() => {
    if (zagruzka) return t('rep.audit.querying');
    if (otkazZaprosa) return t('rep.audit.query_failed', { error: otkazZaprosa });
    if (!otchetOtvet) return t('rep.audit.server_timeout');
    if (otchetOtvet.status === 'NEVER_RUN') return t('rep.audit.never_run');
    if (otchetOtvet.status === 'CACHE_UNREADABLE') return t('rep.audit.cache_unreadable');
    if (otchetOtvet.status === 'INVALID_TENANT') return t('rep.audit.invalid_tenant');
    if (!otchet) return t('rep.audit.no_report');
    return null;
  })();

  // Кнопка ТОЛЬКО открывает существующее окно аудита: второй точки платного
  // запуска здесь не заводится.
  const nuzhnaKnopkaZamera = Boolean(otkazZaprosa)
    || (!zagruzka && Boolean(otchetOtvet)
        && (otchetOtvet.status === 'NEVER_RUN' || otchetOtvet.status === 'CACHE_UNREADABLE'));

  return (
    <div className="min-h-screen bg-surface text-text p-4 lg:p-8 font-sans">
      <div className="max-w-7xl mx-auto space-y-6">

        {/* ШАПКА РАЗДЕЛА: Quiet Luxury Editorial */}
        <Card className="p-6 lg:p-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div>
              <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-wider font-semibold text-accent-ink mb-2">
                <Sparkles className="w-3.5 h-3.5 text-accent" />
                <span>{t('rep.header.badge')}</span>
                {/* 🔴 Город фирмы был вписан в вёрстку. Название главного офиса
                    приходит от держателя; не прочитан — надписи нет. */}
                {officeList.filter((o) => o.is_main).map((o) => (
                  <React.Fragment key={o.kluch}>
                    <span className="text-border">·</span>
                    <span>{o.nazvanie}</span>
                  </React.Fragment>
                ))}
              </div>
              <h1 className="text-2xl lg:text-3xl font-serif text-text font-normal tracking-tight">
                {activeTab === 'marketing' && t('rep.header.tab_marketing_title')}
                {activeTab === 'reputation' && t('rep.header.tab_reputation_title')}
                {activeTab === 'citations' && t('rep.header.tab_citations_title')}
                {activeTab === 'locations' && t('rep.header.tab_locations_title')}
              </h1>
              <p className="text-sm text-text-muted mt-1.5 max-w-2xl leading-relaxed">
                {activeTab === 'marketing' && t('rep.header.tab_marketing_desc')}
                {activeTab === 'reputation' && t('rep.header.tab_reputation_desc')}
                {activeTab === 'citations' && t('rep.header.tab_citations_desc')}
                {activeTab === 'locations' && t('rep.header.tab_locations_desc')}
              </p>
            </div>

            {/* БЫСТРЫЕ ДЕЙСТВИЯ: Agent Battle, Source of Truth, Analytics */}
            <div className="flex flex-wrap items-center gap-2.5">
              {/* 🔴 Кнопки, которым нужен профиль, ВЫКЛЮЧЕНЫ, когда профиля нет:
                   раньше в этом случае открывалось окно с ВЫДУМАННЫМ профилем. */}
<Button
                variant="outline"
                size="sm"
                onClick={() => mainProfile && onOpenAgentBattle && onOpenAgentBattle(mainProfile)}
                disabled={!mainProfile}
                className={`h-10 px-4 gap-2 text-xs font-semibold rounded-xl transition-colors shadow-2xs ${mainProfile ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                style={{ backgroundColor: 'var(--accent-soft)', color: 'var(--accent-ink)', borderColor: 'var(--accent-border)' }}
                title={mainProfile ? t('rep.action.agent_battle') : netProfilya}
              >
                <Swords className="w-4 h-4 text-accent" />
                <span>{t('rep.action.agent_battle')}</span>
              </Button>

<Button
                variant="secondary"
                size="sm"
                onClick={() => mainProfile && onOpenSourceOfTruth && onOpenSourceOfTruth(mainProfile)}
                disabled={!mainProfile}
                className={`h-10 px-4 gap-2 text-xs font-semibold rounded-xl transition-colors shadow-2xs ${mainProfile ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                title={mainProfile ? t('rep.locations.source_of_truth_main') : netProfilya}
              >
                <FileText className="w-4 h-4 text-text-muted" />
                <span>{t('rep.action.source_of_truth')}</span>
              </Button>

<Button
                variant="outline"
                size="sm"
                onClick={() => mainProfile && onOpenAnalytics && onOpenAnalytics(mainProfile)}
                disabled={!mainProfile}
                className={`h-10 px-3.5 gap-2 text-xs font-semibold rounded-xl transition-colors shadow-2xs ${mainProfile ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                title={mainProfile ? t('rep.office.analytics_title') : netProfilya}
              >
                <BarChart3 className="w-4 h-4 text-text-muted" />
                <span>{t('rep.action.analytics')}</span>
              </Button>

<Button
                variant="primary"
                size="sm"
                onClick={handleTriggerAudit}
                disabled={false}
                className="h-10 px-4 gap-2 text-xs font-semibold rounded-xl transition-all shadow-xs cursor-pointer"
              >
                {/* 🔴 Полоска «Auditing (65%)» крутилась от таймера, а не от
                    хода работы: прибор, не связанный с тем, что он показывает. */}
                <ShieldCheck className="w-4 h-4 text-accent" />
                <span>{t('rep.action.run_full_audit')}</span>
              </Button>
            </div>
          </div>

          {/* НАВИГАЦИОННЫЕ ТАБЫ РАЗДЕЛА */}
          <div className="flex items-center gap-2 mt-8 pt-6 border-t border-surface-sunken overflow-x-auto">
            <button
              data-tab="reputation"
              onClick={() => setActiveTab('reputation')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'reputation'
                  ? 'bg-primary text-white'
                  : 'text-text-muted hover:text-text hover:bg-surface-sunken'
              }`}
            >
              {t('rep.tab.reputation')}
            </button>
            <button
              data-tab="gmb_posts"
              onClick={() => setActiveTab('gmb_posts')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'gmb_posts'
                  ? 'bg-primary text-white'
                  : 'text-text-muted hover:text-text hover:bg-surface-sunken'
              }`}
            >
              {t('rep.tab.gmb_posts')}
            </button>
            <button
              data-tab="marketing"
              onClick={() => setActiveTab('marketing')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'marketing'
                  ? 'bg-primary text-white'
                  : 'text-text-muted hover:text-text hover:bg-surface-sunken'
              }`}
            >
              Marketing Pulse
            </button>
            <button
              data-tab="locations"
              onClick={() => setActiveTab('locations')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'locations'
                  ? 'bg-primary text-white'
                  : 'text-text-muted hover:text-text hover:bg-surface-sunken'
              }`}
            >
              {/* 🔴 Здесь стоял запасной ЛИТЕРАЛ «2»: счётчик рапортовал о том,
                   чего не считал, ровно тогда, когда ручка профилей отдавала 500.
                   `profiles` приходит ПРОПОМ с умолчанием `[]`, и пустой массив
                   неотличим от «не передали» — поэтому пусто печатается
                   ПРОЧЕРКОМ, а не нулём: нуля здесь никто не измерял. */}
              {t('rep.tabs.locations', { n: profiles.length > 0 ? profiles.length : NET_CHISLA })}
            </button>
            <button
              data-tab="citations"
              onClick={() => setActiveTab('citations')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'citations'
                  ? 'bg-primary text-white'
                  : 'text-text-muted hover:text-text hover:bg-surface-sunken'
              }`}
            >
              Citations & Directories
            </button>
            <button
              data-tab="opportunities"
              onClick={() => setActiveTab('opportunities')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'opportunities'
                  ? 'bg-primary text-white'
                  : 'text-text-muted hover:text-text hover:bg-surface-sunken'
              }`}
            >
              {t('rep.tab.opportunities')}
            </button>
          </div>
        </Card>

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 1: REPUTATION & PUBLIC TRUST           */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'reputation' && (
          <div className="space-y-6">
            {/* КАРТОЧКИ ВЕРХНЕГО РЯДА: четыре величины ИЗ ОТЧЁТА `/full-audit/latest`.
                🔴 Сводного «скора репутации» здесь НЕТ и быть не может: отчёт не
                содержит его НАРОЧНО (`full_audit_orchestrator.py:548-552`), а сложить
                его на клиенте значило бы назначить веса, которых никто не назначал.
                Каждая величина показана СО СВОИМ знаменателем. */}

            {/* 🔴 ПОДПИСЬ «ЧЕМ И КОГДА МЕРЕНО» — ОДНА, И СТОИТ ДО ЧИСЕЛ.
                Раньше этот блок был в подвале КАЖДОЙ из четырёх карточек и
                читался как отладочный журнал. Подпись не убрана, а СВЕДЕНА в
                одно место: без неё число молча читается как сегодняшнее.
                Плашка рисуется по тому же условию, что и прежний подвал
                (`otchet`), и стоит ВНЕ узлов `[data-card]` — состояния без
                замера по-прежнему говорят сами карточки, каждое своим текстом. */}
            {otchet && <PodpisZameraEdinaya otvet={otchetOtvet} nap={nap} lang={lang} t={t} />}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">

              {/* 1. NAP и цитаты нейросетей — РАЗДЕЛЬНО, две величины, два знаменателя. */}
              <Card data-card="nap-i-citaty" className="p-5 flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-text-muted">{t('rep.card.nap_citations.title')}</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-text-muted mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : (
                    <div className="mt-2 space-y-1">
                      {!nap ? (
                        <div className="text-xs text-text-muted leading-relaxed">{t('rep.card.nap_citations.no_nap')}</div>
                      ) : nap.error === 'canon_not_available' ? (
                        <div className="text-xs text-text-muted leading-relaxed">
                          {t('rep.card.nap_citations.canon_unavailable')}
                        </div>
                      ) : (
                        <>
                          {/* 🔴 Печатается `chislo` — то, что пришло с сервера.
                              Под шкалу подгоняется ТОЛЬКО ширина полосы ниже. */}
                          <div className="text-3xl font-serif text-text leading-none pb-1">
                            NAP: {shkalaNap && shkalaNap.vid === 'est' ? `${shkalaNap.chislo} %` : NET_CHISLA}
                          </div>
                          <Polosa itog={shkalaNap} imya="nap" t={t} />
                          <div className="text-xs text-text-muted pt-0.5">{t('rep.card.nap_citations.measured_den', { n: nap.measured_count, m: nap.total_count })}</div>
                          <div className="text-[10px] text-text-muted leading-relaxed">{t('rep.card.nap_citations.weighted_index')}</div>
                        </>
                      )}
                      {geoItogo ? (
                        <div className="pt-2 border-t border-surface space-y-1">
                          <div className="text-xs text-text">
                            {t('rep.card.nap_citations.ai_citations', {
                              our: (geoItogo.our_citations_total === null || geoItogo.our_citations_total === undefined) ? NET_CHISLA : geoItogo.our_citations_total,
                              total: geoItogo.citations_total,
                            })}
                          </div>
                          <Polosa itog={shkalaCitat} imya="citaty" t={t} />
                        </div>
                      ) : (
                        <div className="text-xs text-text-muted pt-2 border-t border-surface leading-relaxed">{t('rep.card.nap_citations.llm_not_polled')}</div>
                      )}
                      {geoItogo && (geoItogo.our_citations_total === null || geoItogo.our_citations_total === undefined) && (
                        <div className="text-[10px] text-text-muted leading-relaxed">{t('rep.card.nap_citations.no_domain')}</div>
                      )}
                      {otchet && otchet.geo_mode === 'express' && (
                        <div className="text-[10px] text-warning leading-relaxed">
                          {t('rep.card.nap_citations.express_warning')}
                        </div>
                      )}
                    </div>
                  )}
                </div>
{nuzhnaKnopkaZamera && (
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => setAuditOpen(true)}
                    className="mt-3 h-9 px-3 gap-2 text-[11px] font-semibold rounded-xl cursor-pointer"
                  >
                    {t('rep.card.nap_citations.btn_launch')}
                  </Button>
                )}
              </Card>

              {/* 2. Open Issues: длина `prescriptions`, разбивка СЧИТАЕТСЯ из массива. */}
              <Card data-card="open-issues" className="p-5 flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-text-muted">{t('rep.card.open_issues.title')}</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-text-muted mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : predpisaniya ? (
                    <div className="mt-2 space-y-1">
                      <div className="text-2xl font-serif text-text leading-tight">
                        {t('rep.card.open_issues.prescriptions', { n: predpisaniya.length })}
                      </div>
                      {/* 🔴 ТЕКСТОВАЯ ФОРМА «критичных: N» СОХРАНЕНА НАРОЧНО.
                          Её стережёт зонд 7 (`/критичных:\s*3/`), который стоит
                          не для красоты: он доказывает, что разбивка СЧИТАЕТСЯ
                          из массива `prescriptions`, а не написана в вёрстке.
                          Смена словоформы ради косметики ослабила бы работающую
                          проверку; поэтому изменён ВИД бейджа, а не слова. */}
                      <div className="flex flex-wrap items-center gap-1.5 pt-1">
<Badge variant="warning" className="text-[11px] font-semibold">
                          {t('rep.card.open_issues.critical', { n: kritichnyh })}
                        </Badge>
                        <Badge variant="secondary" className="text-[11px] font-semibold">
                          {t('rep.card.open_issues.normal', { n: obychnyh })}
                        </Badge>
                      </div>
                    </div>
                  ) : (
                    <div className="text-xs text-text-muted mt-2 leading-relaxed">{t('rep.card.open_issues.no_prescriptions')}</div>
                  )}
                </div>
              </Card>

              {/* 3. Public Entity Status: утверждение о том, ЧТО ИЗМЕРЕНО.
                  🔴 «Fully Verified» и любые синонимы проверенности убраны: это было
                  утверждением о проверенности без единой проверки. */}
              <Card data-card="entity-status" className="p-5 flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-text-muted">{t('rep.card.entity_status.title')}</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-text-muted mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : (!nap || !nap.canon) ? (
                    <div className="text-xs text-text-muted mt-2 leading-relaxed">{t('rep.card.entity_status.canon_unavailable')}</div>
                  ) : (
                    <div className="mt-2 space-y-1">
                      <div className="text-sm text-text">
                        {t('rep.card.entity_status.canon_locations')}: {Array.isArray(nap.canon.locations) ? nap.canon.locations.length : NET_CHISLA}
                      </div>
                      <div className="text-sm text-text pt-1">
                        {t('rep.card.entity_status.directories_measured', { n: nap.measured_count, m: nap.total_count })}
                      </div>
                      <Polosa itog={shkalaPokrytiya} imya="pokrytie" t={t} />
                      <div className="text-[10px] text-text-muted leading-relaxed pt-0.5">
                        {t('rep.card.entity_status.statement_what_measured')}
                      </div>
                    </div>
                  )}
                </div>
              </Card>

              {/* 4. NAP Baseline (бывшая «30D Health Trend»).
                  🔴 Одна точка — НЕ тренд: ни кривой, ни искры, ни стрелки. */}
              <Card data-card="nap-baseline" className="p-5 flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-text-muted">{t('rep.card.nap_baseline.title')}</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-text-muted mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : (!nap || nap.overall_score === null || nap.overall_score === undefined) ? (
                    <div className="text-xs text-text-muted mt-2 leading-relaxed">{t('rep.card.nap_baseline.no_index')}{NET_CHISLA}</div>
                  ) : (
                    <div className="mt-2 space-y-2">
                      <div className="flex items-baseline gap-2 flex-wrap">
                        <span className="text-3xl font-serif text-text leading-none">
                          {shkalaNap && shkalaNap.vid === 'est' ? `${shkalaNap.chislo} %` : NET_CHISLA}
                        </span>
<Badge variant="secondary" className="text-[10px] font-semibold uppercase tracking-wider">
                          {t('rep.card.nap_baseline.badge')}
                        </Badge>
                      </div>
                      {/* 🔴 ОДНА ТОЧКА НА ПУСТОМ ТРЕКЕ, И ТОЧКА СТОИТ ПО ОСИ
                          ВЕЛИЧИНЫ (0..100), а не по оси времени: одна точка во
                          времени — не тренд, и её горизонтальное положение на
                          временной оси было бы назначено от балды. Ни линии, ни
                          второй точки, ни стрелки здесь нет и быть не может. */}
                      {shkalaNap && shkalaNap.vid === 'est' && (
                        <div className="relative h-3 flex items-center">
                          <div className="absolute inset-x-0 h-1.5 bg-surface-sunken rounded-full" />
                          <div
                            data-shkala="baseline"
                            data-vne-shkaly={shkalaNap.vneShkaly || undefined}
                            data-nol-izmeren={shkalaNap.nolIzmeren ? '1' : undefined}
                            style={{ width: `${shkalaNap.shirina}%` }}
                            className="relative h-1.5"
                          >
                            <span className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-2.5 h-2.5 rounded-full border-2 border-white shadow-xs ${shkalaNap.vneShkaly ? 'bg-warning' : 'bg-accent'}`} />
                          </div>
                        </div>
                      )}
                      <div className="text-[10px] text-text-muted leading-relaxed">
                        {t('rep.card.nap_baseline.recorded_at', { date: nap.measured_at || t('rep.card.nap_baseline.unnamed_moment') })}
                      </div>
                      <div className="text-[10px] text-text-muted leading-relaxed">
                        {t('rep.card.nap_baseline.explanation')}
                      </div>
                    </div>
                  )}
                </div>
              </Card>

            </div>

            {/* БЛОК УПРАВЛЕНИЯ ОФИСАМИ И АРЕНАМИ: офисы канона держателя */}
            <Card className="p-6">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-5 border-b border-surface-sunken">
                <div>
                  <div className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-accent-ink">
                    <Building className="w-3.5 h-3.5 text-accent" />
                    <span>{t('rep.office.header_canon_agents')}</span>
                  </div>
                  <h3 className="text-lg font-serif text-text mt-0.5">{t('rep.office.header_profiles_title')}</h3>
                  <p className="text-xs text-text-muted mt-0.5">{t('rep.office.header_profiles_desc')}</p>
                </div>
              </div>

              <div className="mt-4">
                <SostoyanieOfisov />
              </div>

              {/* Ряд компактных карточек офисов сверху */}
              <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5 ${officeList.length > 2 ? 'lg:grid-cols-3' : 'lg:grid-cols-2'}`}>
                {officeList.map((office) => (
                  <div key={office.kluch} className="flex flex-col">
                    <OfficeCompactCard
                      office={office}
                      isSelected={selectedOffice?.kluch === office.kluch}
                      onSelect={() => handleSelectOffice(office.kluch)}
                    />
                    {/* На мобильных (< 640px) блок разворачивается прямо под выбранной карточкой */}
                    {selectedOffice?.kluch === office.kluch && (
                      <div className="sm:hidden mt-3">
                        <OfficeVisibilityBlock
                          kluch={office.kluch}
                          knownOfficePlaceIds={knownOfficePlaceIds}
                          actionButtons={renderOfficeActionButtons(office)}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* На экранах >= 640px блок деталей открывается во всю ширину под рядом карточек */}
              {selectedOffice && (
                <div className="hidden sm:block mt-5">
                  <OfficeVisibilityBlock
                    kluch={selectedOffice.kluch}
                    knownOfficePlaceIds={knownOfficePlaceIds}
                    actionButtons={renderOfficeActionButtons(selectedOffice)}
                  />
                </div>
              )}
            </Card>

            {/* ОСНОВНОЙ БЛОК: Слева Стратегический план, справа Распределение и проверки */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

              {/* СЛЕВА: Стратегический план действий и Сеть цитирования (2 колонки) */}
              <div className="lg:col-span-2 space-y-6">

                {/* Priority Action Card -> Стратегический план действий */}
                <Card className="p-6">
                  <div className="flex items-center justify-between pb-4 border-b border-surface-sunken">
                    <div className="flex items-center gap-2">
<Badge variant="accent" className="text-[10px] uppercase tracking-wider font-bold">
                        {t('rep.office.strategic_plan_header')}
                      </Badge>
                      <span className="text-xs text-text-muted">{t('rep.office.priority_recommendation')}</span>
                    </div>
                    <Badge variant="secondary" className="text-xs font-semibold">
                      {t('rep.plan.impact_not_evaluated')}
                    </Badge>
                  </div>

                  {strategicPlan ? (
                    <div className="mt-5 space-y-3">
                      <h3 className="text-lg font-serif text-text">
                        {t('rep.plan.title', { office: strategicPlan.officeNazvanie, keyword: strategicPlan.keyword })}
                      </h3>
                      <p className="text-xs text-text-muted leading-relaxed">
                        <span className="font-semibold text-accent-ink">{t('rep.plan.hypothesis_badge')}</span> {t('rep.plan.hypothesis_desc')}
                      </p>

                      <div className="p-4 bg-surface border border-border rounded-xl text-xs space-y-2">
                        <div className="flex items-center justify-between text-text-muted">
                          <span>{t('rep.plan.office_query')}</span>
                          <strong className="text-text">{strategicPlan.officeNazvanie} · «{strategicPlan.keyword}»</strong>
                        </div>
                        <div className="flex items-center justify-between text-text-muted">
                          <span>{t('rep.plan.grid_positions')}</span>
                          <span className="text-text font-medium">
                            {strategicPlan.top3Count !== null && strategicPlan.totalRequested !== null
                              ? t('rep.plan.top3_count', { n: strategicPlan.top3Count, m: strategicPlan.totalRequested, pct: Math.round(strategicPlan.top3Share * 100) })
                              : t('rep.plan.top3_share', { pct: Math.round(strategicPlan.top3Share * 100) })}
                            {' · '}
                            {strategicPlan.top10Share !== null
                              ? (strategicPlan.top10Count !== null && strategicPlan.totalRequested !== null
                                  ? t('rep.plan.top10_count', { n: strategicPlan.top10Count, m: strategicPlan.totalRequested, pct: Math.round(strategicPlan.top10Share * 100) })
                                  : t('rep.plan.top10_share', { pct: Math.round(strategicPlan.top10Share * 100) }))
                              : t('rep.plan.top10_not_measured')}
                          </span>
                        </div>
                        <div className="flex items-center justify-between text-text-muted">
                          <span>{t('rep.plan.coverage_label')}</span>
                          <span className="text-text">
                            {strategicPlan.foundCount !== null
                              ? (strategicPlan.totalRequested !== null
                                  ? `${t('rep.plan.found_in_points', { found: strategicPlan.foundCount, total: strategicPlan.totalRequested })}${strategicPlan.notFoundCount > 0 ? ` ${t('rep.plan.not_found_points', { n: strategicPlan.notFoundCount })}` : ''}`
                                  : t('rep.plan.found_simple', { found: strategicPlan.foundCount }))
                              : t('rep.state.not_measured')}
                          </span>
                        </div>
                        {strategicPlan.topCompetitors.length > 0 && (
                          <div className="flex items-center justify-between text-text-muted">
                            <span>{t('rep.plan.leaders_label')}</span>
                            <span className="text-text font-medium truncate max-w-[260px]" title={strategicPlan.topCompetitors.join(', ')}>
                              {strategicPlan.topCompetitors.join(', ')}
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="p-3 bg-surface border border-border rounded-xl text-[11px] text-text-muted flex items-center justify-between">
                        <span>{t('rep.plan.recommendation')}</span>
                        <span className="font-semibold text-text">{t('rep.plan.next_scan')}</span>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-5 space-y-3">
                      <p className="text-xs text-text-muted leading-relaxed">
                        {t('rep.plan.no_scans')}
                      </p>
                    </div>
                  )}
                </Card>

                {/* Directory Presence Cards */}
                <Card className="p-6">
                  <div className="flex items-center justify-between mb-5">
                    <div>
                      <h3 className="text-base font-serif text-text">Active Directory Authority</h3>
                      <p className="text-xs text-text-muted mt-0.5">{t('rep.directory_presence.desc')}</p>
                    </div>
                    {/* 🔴 «6 of 6 Verified» держалось на длине зашитого списка,
                        а не на проверке хотя бы одной записи. */}
                    <span className="text-[11px] font-semibold text-text-muted bg-surface-sunken px-2.5 py-1 rounded-md">
                      {t('rep.directory_presence.no_check')}
                    </span>
                  </div>

                  <SostoyanieOfisov />

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5">
                    {officeList.map((o) => (
                      <div
                        key={o.kluch}
                        className="p-4 rounded-xl border border-border bg-surface-raised space-y-2.5 block"
                      >
                        <div className="flex items-start justify-between">
                          <div>
                            <div className="text-xs font-semibold text-text">
                              Google Business Profile · {o.nazvanie}
                            </div>
                            <div className="text-[11px] text-text-muted mt-0.5">{o.address}</div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between text-xs pt-2 border-t border-surface-sunken">
                          {/* 🔴 Ссылки на запись в Google здесь НЕТ НАРОЧНО: в каноне
                              её нет, а написанная от руки ссылка — утверждение о мире. */}
                          <span className="text-[10px] text-text-muted">
                            {t('rep.directory_presence.unverified')}
                          </span>
                          <span className="text-[10px] text-accent-ink font-medium">{o.badge}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </Card>

              </div>

              {/* СПРАВА: Распределение категорий и Журнал верификаций (1 колонка) */}
              <div className="space-y-6">

                {/* Issue Distribution Card -> Распределение сигналов */}
                <Card className="p-6">
                  <h3 className="text-base font-serif text-text">{t('rep.signals.title')}</h3>
                  {/* 🔴 УБРАНЫ ЧЕТЫРЕ КАТЕГОРИИ С ЧИСЛАМИ И ДОЛЯМИ (42 / 58,3 %,
                      18 / 25,0 %, 11 / 15,3 %, 1 / 1,4 %) и полоса, ширина
                      которой рисовалась ИЗ ТЕХ ЖЕ литералов. Подпись «72
                      verified signals» — их сумма, то есть тоже литерал. */}
                  <p className="text-xs text-text-muted mt-0.5 mb-5 leading-relaxed">{t('rep.fallback.no_source_long')}</p>
                </Card>

                {/* Recent Automated Audits -> История аудитов и замеров */}
                <Card className="p-6">
                  <div className="flex items-center justify-between pb-3 border-b border-surface-sunken">
                    <div>
                      <h3 className="text-base font-serif text-text">{t('rep.audit_history.title')}</h3>
                      <p className="text-[11px] text-text-muted mt-0.5">{t('rep.audit_history.desc')}</p>
                    </div>
                    {geogridHistory.length > 0 && (
                      <span className="text-[10px] font-bold text-success bg-success-soft border border-success-border px-2 py-0.5 rounded">
                        {sklonit('rep.plural.zamerov', geogridHistory.length)}
                      </span>
                    )}
                  </div>

                  {geogridHistoryLoading ? (
                    <div className="py-4 space-y-2 animate-pulse">
                      <div className="h-12 bg-surface rounded-xl" />
                      <div className="h-12 bg-surface rounded-xl" />
                    </div>
                  ) : geogridHistory.length > 0 ? (
                    <div className="space-y-3 mt-3">
                      {geogridHistory.map((run, idx) => (
                        <div
                          key={run.runId || idx}
                          className="p-3.5 rounded-xl border border-border bg-surface-raised text-xs space-y-2"
                        >
                          <div className="flex items-center justify-between">
                            <span className="font-semibold text-text">{run.officeNazvanie}</span>
                            <span className="text-[9px] font-bold text-success bg-success-soft border border-success-border px-1.5 py-0.5 rounded">
                              {run.status === 'SUCCESS' || run.status === 'COMPLETED' ? t('rep.audit_history.status_success') : run.status}
                            </span>
                          </div>

                          <div className="text-[11px] text-text-muted flex items-center justify-between">
                            <span>{t('rep.audit_history.scan_time')}</span>
                            <span className="font-semibold text-text">
                              {formatEdtDateTime(run.startedAt, lang)}
                            </span>
                          </div>

                          <div className="text-[11px] text-text-muted flex items-center justify-between">
                            <span>{t('rep.audit_history.queries_count', { n: run.keywordsCount })}</span>
                            <span className="font-medium text-text truncate max-w-[140px]" title={run.keywordsList.join(', ')}>
                              {run.keywordsList.slice(0, 2).join(', ')}{run.keywordsCount > 2 ? '...' : ''}
                            </span>
                          </div>

                          <div className="text-[11px] text-text-muted flex items-center justify-between">
                            <span>{t('rep.audit_history.queries_list')}</span>
                            <span className="font-semibold text-text">
                              {run.keywordsSource === 'OS'
                                ? t('rep.audit_history.source_os')
                                : run.keywordsSource === 'config'
                                ? t('rep.audit_history.source_config')
                                : run.keywordsSource === 'config_fallback'
                                ? (run.keywordsSourceReason ? t('rep.audit_history.source_fallback_reason', { reason: run.keywordsSourceReason }) : t('rep.audit_history.source_fallback'))
                                : t('rep.audit_history.source_not_specified')}
                            </span>
                          </div>

                          {run.c2Reputation?.status === 'measured' && run.c2Reputation.rating !== null && (
                            <div className="text-[11px] text-text-muted flex items-center justify-between">
                              <span>{t('rep.audit_history.google_rating')}</span>
                              <span className="font-semibold text-text" title={run.c2Reputation.signature}>
                                ★ {run.c2Reputation.rating.toFixed(1)} · {run.c2Reputation.reviews_count !== null ? sklonit('rep.plural.otzyvov', run.c2Reputation.reviews_count) : '—'}
                              </span>
                            </div>
                          )}

                          <div className="text-[10px] text-accent-ink flex items-center justify-between pt-1.5 border-t border-surface-sunken">
                            <span>{t('rep.audit_history.grid', { coverage: run.coverage })}</span>
                            <span>{run.origin} · {run.provider}</span>
                          </div>
                        </div>
                      ))}
                      <div className="text-[10px] text-text-muted pt-2 border-t border-surface-sunken">
                        {t('rep.audit_history.schedule')}
                      </div>
                    </div>
                  ) : (
                    <p className="text-xs text-text-muted mt-3 leading-relaxed">
                      {t('rep.audit_history.empty')}
                    </p>
                  )}
                </Card>

              </div>

            </div>
          </div>
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 2: MARKETING PULSE                      */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'marketing' && (
          <div className="space-y-6">

            {/* ГЛАВНЫЙ ГРАФИК СПРОСА И КОНВЕРСИЙ */}
            <Card className="p-6 lg:p-8">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 pb-6 border-b border-surface-sunken">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-accent-ink">Acquisition & Conversion</div>
                  <h2 className="text-xl font-serif text-text mt-0.5">Demand and conversion trend</h2>
                  <p className="text-xs text-text-muted mt-0.5">Tracking high-intent calls, bookings, and organic lead acquisition.</p>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  {/* Переключатель 30d / 90d */}
                  <div className="inline-flex bg-surface p-1 rounded-xl border border-border">
                    <button
                      onClick={() => setTimeframe('30d')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        timeframe === '30d' ? 'bg-white text-text shadow-2xs' : 'text-text-muted hover:text-text'
                      }`}
                    >
                      30 days
                    </button>
                    <button
                      onClick={() => setTimeframe('90d')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        timeframe === '90d' ? 'bg-white text-text shadow-2xs' : 'text-text-muted hover:text-text'
                      }`}
                    >
                      90 days
                    </button>
                  </div>

                  {/* Переключатель фокуса метрики */}
                  <div className="inline-flex bg-surface p-1 rounded-xl border border-border">
                    <button
                      onClick={() => setMetricType('leads')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        metricType === 'leads' ? 'bg-primary text-white' : 'text-text-muted hover:text-text'
                      }`}
                    >
                      Leads
                    </button>
                    <button
                      onClick={() => setMetricType('booked')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        metricType === 'booked' ? 'bg-success text-white' : 'text-text-muted hover:text-text'
                      }`}
                    >
                      Booked calls
                    </button>
                    <button
                      onClick={() => setMetricType('organic')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        metricType === 'organic' ? 'bg-accent-ink text-white' : 'text-text-muted hover:text-text'
                      }`}
                    >
                      Organic reach
                    </button>
                  </div>
                </div>
              </div>

              {/* Легенда */}
              <div className="flex items-center gap-6 mt-6 mb-4 text-xs font-semibold">
                <div className="flex items-center gap-2 text-text">
                  <span className="w-3 h-3 rounded-full bg-accent" />
                  <span>Total Inquiries (Leads)</span>
                </div>
                <div className="flex items-center gap-2 text-success">
                  <span className="w-3 h-3 rounded-full bg-success" />
                  <span>Booked Consultations</span>
                </div>
                <div className="flex items-center gap-2 text-accent-ink">
                  <span className="w-3 h-3 rounded-full bg-accent-ink" />
                  <span>Organic Search Reach</span>
                </div>
              </div>

              {/* ГРАФИК СПРОСА И КОНВЕРСИЙ */}
              {metricType === 'leads' ? (
                pulseLoading ? (
                  <div className="w-full mt-4 p-8 rounded-xl border border-dashed border-border bg-surface text-center animate-pulse">
                    <div className="text-xs text-text-muted">{t('rep.pulse.loading_inquiry_data')}</div>
                  </div>
                ) : pulseError || pulseData?.status === 'unavailable' ? (
                  <div className="w-full mt-4 p-8 rounded-xl border border-rose-200 bg-rose-50/50 text-center">
                    <div className="text-xs text-rose-800 font-medium">
                      {t('rep.pulse.failed_inquiry_data', { error: pulseError || pulseData?.detail || t('rep.error.db_read_unmeasured') })}
                    </div>
                  </div>
                ) : pulseData?.daily_curve && pulseData.daily_curve.length > 0 ? (
                  <div className="mt-4 space-y-3">
                    <div className="w-full p-4 rounded-xl border border-border bg-surface-raised">
                      {(() => {
                        const curve = pulseData.daily_curve;
                        const maxVal = Math.max(1, ...curve.map((c) => c.leads));
                        const svgWidth = 800;
                        const svgHeight = 160;
                        const padX = 20;
                        const padY = 25;
                        const chartW = svgWidth - padX * 2;
                        const chartH = svgHeight - padY * 2;
                        const barW = Math.max(2, (chartW / curve.length) * 0.7);

                        const cutoffDate = pulseData.cutoff?.date;
                        const cutoffIdx = cutoffDate ? curve.findIndex((c) => c.date === cutoffDate) : -1;
                        const cutoffX = cutoffIdx >= 0 ? padX + (cutoffIdx / curve.length) * chartW + barW / 2 : null;

                        return (
                          <div className="relative w-full overflow-hidden">
                            <svg viewBox={`0 0 ${svgWidth} ${svgHeight}`} className="w-full h-44 select-none">
                              <line x1={padX} y1={padY} x2={svgWidth - padX} y2={padY} stroke="var(--surface-sunken)" strokeDasharray="3 3" />
                              <line x1={padX} y1={padY + chartH / 2} x2={svgWidth - padX} y2={padY + chartH / 2} stroke="var(--surface-sunken)" strokeDasharray="3 3" />
                              <line x1={padX} y1={padY + chartH} x2={svgWidth - padX} y2={padY + chartH} stroke="var(--border)" />

                              <text x={padX - 4} y={padY + 4} textAnchor="end" fontSize="10" fill="var(--text-muted)">{maxVal}</text>
                              <text x={padX - 4} y={padY + chartH + 3} textAnchor="end" fontSize="10" fill="var(--text-muted)">0</text>

                              {curve.map((pt, idx) => {
                                const x = padX + (idx / curve.length) * chartW;
                                const h = (pt.leads / maxVal) * chartH;
                                const y = padY + chartH - h;
                                const isCutoff = cutoffDate && pt.date <= cutoffDate;

                                return (
                                  <g key={pt.date} className="group">
                                    <rect
                                      x={x}
                                      y={y}
                                      width={barW}
                                      height={Math.max(2, h)}
                                      rx={1.5}
                                      fill={pt.leads > 0 ? (isCutoff ? 'var(--warning)' : 'var(--accent)') : 'var(--border)'}
                                      className="transition-all hover:opacity-80 cursor-pointer"
                                    >
                                      <title>{`${pt.date}: ${sklonit('rep.plural.obrashcheniy', pt.leads)}`}</title>
                                    </rect>
                                  </g>
                                );
                              })}

                              {cutoffX !== null && (
                                <g>
                                  <line
                                    x1={cutoffX}
                                    y1={padY - 8}
                                    x2={cutoffX}
                                    y2={padY + chartH + 8}
                                    stroke="var(--danger)"
                                    strokeWidth="1.5"
                                    strokeDasharray="4 3"
                                  />
                                  <text x={cutoffX + 4} y={padY + 12} fontSize="9" fill="var(--danger)" fontWeight="bold">
                                    {t('rep.pulse.cutoff_27_08')}
                                  </text>
                                </g>
                              )}
                            </svg>

                            <div className="flex justify-between text-[10px] text-accent-ink px-4 pt-1">
                              <span>{curve[0]?.date}</span>
                              <span>{curve[Math.floor(curve.length / 2)]?.date}</span>
                              <span>{curve[curve.length - 1]?.date}</span>
                            </div>
                          </div>
                        );
                      })()}
                    </div>

                    {pulseData.cutoff && (
                      <div className="p-3 bg-warning-soft border border-warning-border rounded-xl text-xs text-warning flex items-start gap-2">
                        <AlertTriangle className="w-4 h-4 text-warning shrink-0 mt-0.5" />
                        <div>
                          <span className="font-semibold">{t('rep.pulse.cutoff_prefix', { date: pulseData.cutoff.date })}</span>{' '}
                          {pulseData.cutoff.code === 'intake_lost_leads_before_date'
                            ? t('rep.pulse.cutoff.intake_lost_leads_before_date')
                            : pulseData.cutoff.note}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="w-full mt-4 p-8 rounded-xl border border-dashed border-border bg-surface text-center">
                    <div className="text-xs text-text-muted leading-relaxed max-w-lg mx-auto">
                      {t('rep.fallback.no_source_long')} {t('rep.pulse.no_inquiries_in_window')}
                    </div>
                  </div>
                )
              ) : metricType === 'booked' ? (
                <div className="w-full mt-4 p-8 rounded-xl border border-dashed border-border bg-surface text-center">
                  <div className="text-xs text-text-muted leading-relaxed max-w-lg mx-auto">
                    {t('rep.pulse.booked_curve_not_built', {
                      reason: formatBookedConsultsReason(pulseData?.summary_cards?.booked_consults?.reason) || t('rep.pulse.booked_consults.caption')
                    })}
                  </div>
                </div>
              ) : (
                /* metricType === 'organic' */
                gscLoading ? (
                  <div className="w-full mt-4 p-8 rounded-xl border border-dashed border-border bg-surface text-center animate-pulse">
                    <div className="text-xs text-text-muted">{t('rep.pulse.loading_gsc')}</div>
                  </div>
                ) : gscData?.status === 'ok' && gscData.daily_curve && gscData.daily_curve.length > 0 ? (
                  <div className="mt-4 space-y-3">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 p-4 bg-surface-raised border border-border rounded-xl">
                      <div>
                        <div className="text-[10px] text-text-muted uppercase font-semibold">{t('rep.gsc.clicks')}</div>
                        <div className="text-xl font-serif text-text mt-0.5">
                          {typeof gscData.clicks === 'number' ? gscData.clicks : NET_CHISLA}
                        </div>
                      </div>
                      <div>
                        <div className="text-[10px] text-text-muted uppercase font-semibold">{t('rep.gsc.impressions')}</div>
                        <div className="text-xl font-serif text-text mt-0.5">
                          {typeof gscData.impressions === 'number' ? gscData.impressions : NET_CHISLA}
                        </div>
                      </div>
                      <div>
                        <div className="text-[10px] text-text-muted uppercase font-semibold">{t('rep.gsc.ctr')}</div>
                        <div className="text-xl font-serif text-text mt-0.5">
                          {typeof gscData.ctr === 'number' ? `${(gscData.ctr * 100).toFixed(2)}%` : NET_CHISLA}
                        </div>
                      </div>
                      <div>
                        <div className="text-[10px] text-text-muted uppercase font-semibold">{t('rep.gsc.position')}</div>
                        <div className="text-xl font-serif text-text mt-0.5">
                          {typeof gscData.position === 'number' ? gscData.position : NET_CHISLA}
                        </div>
                      </div>
                    </div>

                    <div className="w-full p-4 rounded-xl border border-border bg-surface-raised">
                      {(() => {
                        const curve = gscData.daily_curve;
                        const maxVal = Math.max(1, ...curve.map((c) => c.clicks));
                        const svgWidth = 800;
                        const svgHeight = 160;
                        const padX = 20;
                        const padY = 25;
                        const chartW = svgWidth - padX * 2;
                        const chartH = svgHeight - padY * 2;
                        const barW = Math.max(2, (chartW / curve.length) * 0.7);

                        return (
                          <div className="relative w-full overflow-hidden">
                            <svg viewBox={`0 0 ${svgWidth} ${svgHeight}`} className="w-full h-44 select-none">
                              <line x1={padX} y1={padY} x2={svgWidth - padX} y2={padY} stroke="var(--surface-sunken)" strokeDasharray="3 3" />
                              <line x1={padX} y1={padY + chartH / 2} x2={svgWidth - padX} y2={padY + chartH / 2} stroke="var(--surface-sunken)" strokeDasharray="3 3" />
                              <line x1={padX} y1={padY + chartH} x2={svgWidth - padX} y2={padY + chartH} stroke="var(--border)" />

                              <text x={padX - 4} y={padY + 4} textAnchor="end" fontSize="10" fill="var(--text-muted)">{maxVal}</text>
                              <text x={padX - 4} y={padY + chartH + 3} textAnchor="end" fontSize="10" fill="var(--text-muted)">0</text>

                              {curve.map((pt, idx) => {
                                const x = padX + (idx / curve.length) * chartW;
                                const h = (pt.clicks / maxVal) * chartH;
                                const y = padY + chartH - h;

                                return (
                                  <g key={pt.date} className="group">
                                    <rect
                                      x={x}
                                      y={y}
                                      width={barW}
                                      height={Math.max(2, h)}
                                      rx={1.5}
                                      fill={pt.clicks > 0 ? 'var(--accent-ink)' : 'var(--border)'}
                                      className="transition-all hover:opacity-80 cursor-pointer"
                                    >
                                      <title>
                                        {t('rep.gsc.chart_tooltip', {
                                          date: pt.date,
                                          clicks: sklonit('rep.plural.klikov', pt.clicks),
                                          impressions: sklonit('rep.plural.pokazov', pt.impressions),
                                          ctr: (pt.ctr * 100).toFixed(1),
                                          pos_label: t('rep.gsc.pos_label'),
                                          pos: pt.position,
                                        })}
                                      </title>
                                    </rect>
                                  </g>
                                );
                              })}
                            </svg>

                            <div className="flex justify-between text-[10px] text-accent-ink px-4 pt-1">
                              <span>{curve[0]?.date}</span>
                              <span>{curve[Math.floor(curve.length / 2)]?.date}</span>
                              <span>{curve[curve.length - 1]?.date}</span>
                            </div>
                          </div>
                        );
                      })()}
                    </div>

                    <div className="p-3 bg-surface border border-border rounded-xl text-xs text-text-muted flex items-center justify-between">
                      <span className="font-medium text-text">
                        {gscData.code
                          ? (gscData.code === 'data_with_lag'
                              ? t('rep.gsc.caption.data_with_lag', { date: gscData.last_date, lag: gscData.lag_days || 2 })
                              : gscData.code === 'stale_since'
                              ? t('rep.gsc.caption.stale_since', { date: gscData.last_date })
                              : gscData.code === 'no_impressions'
                              ? t('rep.gsc.caption.no_impressions', { date: gscData.last_date })
                              : t('rep.gsc.caption.no_source'))
                          : gscData.caption}
                      </span>
                      {gscData.is_stale && (
                        <span className="text-warning font-semibold flex items-center gap-1">
                          <AlertTriangle className="w-3.5 h-3.5" />
                          {t('rep.pulse.stale_slice')}
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="w-full mt-4 p-8 rounded-xl border border-dashed border-border bg-surface text-center">
                    <div className="text-xs text-text-muted leading-relaxed max-w-lg mx-auto">
                      {t('rep.fallback.no_source_long')}{' '}
                      {t('rep.gsc.curve_not_built', {
                        detail: gscData?.code
                          ? t(`rep.gsc.caption.${gscData.code}`, { date: gscData.last_date, lag: gscData.lag_days })
                          : (gscData?.detail || gscError || pulseData?.unmeasured_reasons?.organic_reach || t('rep.pulse.unmeasured.gsc_not_connected'))
                      })}
                    </div>
                  </div>
                )
              )}

              {/* Метрики сводки */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-surface-sunken">
                {/* Total Inquiries */}
                <div>
                  <div className="text-[11px] text-text-muted uppercase tracking-wider font-semibold">Total Inquiries</div>
                  <div className="text-2xl font-serif text-text mt-0.5">
                    {pulseData?.status === 'ok' ? pulseData.total_inquiries : NET_CHISLA}
                  </div>
                  <div className="text-xs text-text-muted font-medium mt-0.5">
                    {pulseData?.status === 'ok'
                      ? (pulseData.summary_cards?.total_inquiries?.code === 'active_inquiries'
                          ? t('rep.pulse.total_inquiries.active', { timeframe: t(`rep.timeframe.${timeframe}`) })
                          : (pulseData.summary_cards?.total_inquiries?.caption || t('rep.pulse.total_inquiries.active', { timeframe: t(`rep.timeframe.${timeframe}`) })))
                      : (pulseData?.detail || t('rep.state.not_measured'))}
                  </div>
                  <div className="text-[10px] text-accent-ink mt-0.5">
                    {t('rep.pulse.active_leads_data')}
                  </div>
                </div>

                {/* Booked Consults */}
                <div>
                  <div className="text-[11px] text-text-muted uppercase tracking-wider font-semibold">Booked Consults</div>
                  <div className="text-2xl font-serif text-text mt-0.5">{NET_CHISLA}</div>
                  <div className="text-xs text-text-muted font-medium mt-0.5">
                    {pulseData?.summary_cards?.booked_consults?.code === 'booked_outside_os'
                      ? t('rep.pulse.booked_consults.caption')
                      : (pulseData?.summary_cards?.booked_consults?.caption || t('rep.pulse.booked_consults.caption'))}
                  </div>
                  <div className="text-[10px] text-accent-ink mt-0.5 leading-tight">
                    {pulseData?.summary_cards?.booked_consults?.code === 'booked_outside_os'
                      ? t('rep.pulse.booked_consults.reason', {
                          zapisi: sklonit('rep.plural.zapisi', pulseData.summary_cards.booked_consults.n),
                          na_obrashcheniy: sklonit('rep.plural.na_obrashcheniy', pulseData.summary_cards.booked_consults.m, { m: pulseData.summary_cards.booked_consults.m }),
                        })
                      : (formatBookedConsultsReason(pulseData?.summary_cards?.booked_consults?.reason) || t('rep.pulse.booked_consults.caption'))}
                  </div>
                </div>

                {/* Avg Conversion */}
                <div>
                  <div className="text-[11px] text-text-muted uppercase tracking-wider font-semibold">Avg Conversion</div>
                  <div className="text-2xl font-serif text-text mt-0.5">{NET_CHISLA}</div>
                  <div className="text-xs text-text-muted font-medium mt-0.5">
                    {pulseData?.summary_cards?.avg_conversion?.code === 'statuses_not_tracked'
                      ? t('rep.pulse.avg_conversion.caption')
                      : (pulseData?.summary_cards?.avg_conversion?.caption || t('rep.pulse.avg_conversion.caption'))}
                  </div>
                  <div className="text-[10px] text-accent-ink mt-0.5 leading-tight">
                    {pulseData?.summary_cards?.avg_conversion?.code === 'statuses_not_tracked'
                      ? t('rep.pulse.avg_conversion.reason', {
                          n: pulseData.summary_cards.avg_conversion.n,
                          m: pulseData.summary_cards.avg_conversion.m,
                        })
                      : (pulseData?.summary_cards?.avg_conversion?.reason || t('rep.pulse.avg_conversion.caption'))}
                  </div>
                </div>

                {/* Revenue Pipeline */}
                <div>
                  <div className="text-[11px] text-text-muted uppercase tracking-wider font-semibold">Revenue Pipeline</div>
                  <div className="text-2xl font-serif text-text mt-0.5">{NET_CHISLA}</div>
                  <div className="text-xs text-text-muted font-medium mt-0.5">
                    {pulseData?.summary_cards?.revenue_pipeline?.code === 'no_revenue_in_os'
                      ? t('rep.pulse.revenue_pipeline.caption')
                      : (pulseData?.summary_cards?.revenue_pipeline?.caption || t('rep.pulse.revenue_pipeline.caption'))}
                  </div>
                  <div className="text-[10px] text-accent-ink mt-0.5 leading-tight">
                    {pulseData?.summary_cards?.revenue_pipeline?.code === 'no_revenue_in_os'
                      ? t('rep.pulse.revenue_pipeline.reason')
                      : (pulseData?.summary_cards?.revenue_pipeline?.reason || t('rep.pulse.revenue_pipeline.caption'))}
                  </div>
                </div>
              </div>
            </Card>

            {/* 4 КАРТОЧКИ КАНАЛОВ ПРИВЛЕЧЕНИЯ */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {(pulseData?.channels || [
                { id: 'voice', name: 'Voice AI (Sofia)', leads_count: null },
                { id: 'email', name: 'Email (Sofia AI)', leads_count: null },
                { id: 'form', name: 'Website form', leads_count: null },
                { id: 'chat', name: 'Website Chat (Sofia)', leads_count: null }
              ]).map(channel => {
                const Icon = channel.id === 'voice' ? PhoneCall
                  : channel.id === 'email' ? Mail
                  : channel.id === 'form' ? Globe
                  : MessageSquare;
                const isMeasured = pulseData?.status === 'ok' && typeof channel.leads_count === 'number';

                return (
                  <Card key={channel.id} className="bg-white rounded-2xl p-5 flex flex-col justify-between space-y-4">
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <div className="w-8 h-8 rounded-xl bg-surface border border-border flex items-center justify-center text-text">
                          <Icon className="w-4 h-4" />
                        </div>
                      </div>

                      <h3 className="text-sm font-semibold text-text">{tIliZapasnoe('rep.channel_title.' + channel.id, undefined, channel.name)}</h3>

                      <div className="mt-3 flex items-baseline justify-between">
                        <span className="text-2xl font-serif font-normal text-text">
                          {isMeasured ? channel.leads_count : NET_CHISLA}
                        </span>
                        <span className="text-xs text-text-muted">
                          {channel.conversion_code === 'conversion_not_measured'
                            ? t('rep.pulse.conversion_not_measured')
                            : (channel.conversion_note || t('rep.pulse.conversion_not_measured'))}
                        </span>
                      </div>
                    </div>

                    <div className="pt-3 border-t border-surface text-[11px] text-text-muted leading-relaxed">
                      {isMeasured ? (
                        <div>
                          <div className="font-medium text-text">
                            {channel.code === 'channel_stats'
                              ? (channel.id === 'voice' && channel.calls_count != null
                                  ? t('rep.channel.voice', {
                                      leads: sklonit('rep.plural.obrashcheniy', channel.leads_count),
                                      calls: sklonit('rep.plural.zvonkov', channel.calls_count),
                                      timeframe: t(`rep.timeframe.${timeframe}`),
                                    })
                                  : (channel.id === 'chat' || channel.id === 'web_chat') && channel.sessions_count != null
                                  ? t('rep.channel.chat', {
                                      leads: sklonit('rep.plural.obrashcheniy', channel.leads_count),
                                      sessions: sklonit('rep.plural.sessiy', channel.sessions_count),
                                      timeframe: t(`rep.timeframe.${timeframe}`),
                                    })
                                  : tIliZapasnoe(`rep.channel.${channel.id}`, {
                                      leads: sklonit('rep.plural.obrashcheniy', channel.leads_count),
                                      timeframe: t(`rep.timeframe.${timeframe}`),
                                    }, t('rep.channel.other', {
                                      leads: sklonit('rep.plural.obrashcheniy', channel.leads_count),
                                      timeframe: t(`rep.timeframe.${timeframe}`),
                                    })))
                              : channel.caption}
                          </div>
                          {channel.calls_count != null && (
                            <div className="text-[10px] text-accent-ink mt-0.5">
                              {t('rep.pulse.channel_inbound_calls', { n: channel.calls_count })}
                            </div>
                          )}
                          {channel.sessions_count != null && (
                            <div className="text-[10px] text-accent-ink mt-0.5">
                              {t('rep.pulse.channel_chat_sessions', { n: channel.sessions_count })}
                            </div>
                          )}
                        </div>
                      ) : (
                        <p>{pulseData?.detail || t('rep.fallback.no_source_long')}</p>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>

            {/* БЛОК ДРУГИХ КАНАЛОВ И ПРИЧИН ИХ НЕИЗМЕРЕННОСТИ */}
            <Card variant="sunken" className="p-5 shadow-xs">
              <div className="text-xs font-semibold text-text mb-3 flex items-center gap-1.5">
                <Info className="w-4 h-4 text-accent" />
                <span>{t('rep.pulse.other_channels_title')}</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs text-text-muted">
                <div className="p-3 bg-white rounded-xl border border-border">
                  <div className="font-medium text-text">Google Maps</div>
                  <div className="text-[11px] mt-1 text-accent-ink">
                    {pulseData?.unmeasured_codes?.google_maps
                      ? t(`rep.pulse.unmeasured.${pulseData.unmeasured_codes.google_maps}`)
                      : (pulseData?.unmeasured_reasons?.google_maps || t('rep.pulse.unmeasured.pending_gbp_api'))}
                  </div>
                </div>
                <div className="p-3 bg-white rounded-xl border border-border">
                  <div className="font-medium text-text">Referrals & Attorney Network</div>
                  <div className="text-[11px] mt-1 text-accent-ink">
                    {pulseData?.unmeasured_codes?.referrals
                      ? t(`rep.pulse.unmeasured.${pulseData.unmeasured_codes.referrals}`)
                      : (pulseData?.unmeasured_reasons?.referrals || t('rep.pulse.unmeasured.referral_source_not_asked'))}
                  </div>
                </div>
                <div className="p-3 bg-white rounded-xl border border-border">
                  <div className="flex items-center justify-between">
                    <div className="font-medium text-text">Organic Search Reach</div>
                    {gscData?.status === 'ok' && typeof gscData.clicks === 'number' && (
                      <span className="text-xs font-semibold text-text">
                        {sklonit('rep.plural.klikov', gscData.clicks)}
                      </span>
                    )}
                  </div>
                  <div className="text-[11px] mt-1 text-accent-ink">
                    {gscData?.code
                      ? (gscData.code === 'data_with_lag'
                          ? t('rep.gsc.caption.data_with_lag', { date: gscData.last_date, lag: gscData.lag_days || 2 })
                          : gscData.code === 'stale_since'
                          ? t('rep.gsc.caption.stale_since', { date: gscData.last_date })
                          : gscData.code === 'no_impressions'
                          ? t('rep.gsc.caption.no_impressions', { date: gscData.last_date })
                          : t('rep.gsc.caption.no_source'))
                      : (gscData?.status === 'ok'
                          ? gscData.caption
                          : (gscData?.status === 'no_data' || !gscData
                              ? t('rep.state.no_source')
                              : (pulseData?.unmeasured_reasons?.organic_reach || t('rep.state.no_source'))))}
                  </div>
                  {gscData?.status === 'ok' && typeof gscData.impressions === 'number' && (
                    <div className="text-[10px] text-text-muted mt-1 flex gap-3">
                      <span>{t('rep.gsc.impressions').toLowerCase()}: {gscData.impressions}</span>
                      <span>{t('rep.gsc.ctr')}: {(gscData.ctr * 100).toFixed(1)}%</span>
                      <span>{t('rep.gsc.pos_label')}: {gscData.position}</span>
                    </div>
                  )}
                </div>
              </div>
            </Card>

          </div>
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 3: OFFICE PROFILES & TRUTH ANCHORS                                */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'locations' && (
          <div className="space-y-6">
            <Card className="p-6 lg:p-8">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-6 border-b border-surface-sunken">
                <div>
                  <h2 className="text-xl font-serif text-text">{t('rep.locations.title')}</h2>
                  <p className="text-xs text-text-muted mt-1 leading-relaxed">
                    {t('rep.locations.subtitle')}
                  </p>
                </div>

                <div className="flex items-center gap-3">
<Button
                    variant="primary"
                    size="sm"
                    onClick={() => mainProfile && onOpenSourceOfTruth && onOpenSourceOfTruth(mainProfile)}
                    disabled={!mainProfile}
                    className={`h-9 px-4 gap-2 text-xs font-semibold rounded-xl transition-colors shadow-xs ${mainProfile ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                    title={mainProfile ? t('rep.locations.source_of_truth_main') : netProfilya}
                  >
                    <FileText className="w-3.5 h-3.5 text-accent" />
                    <span>{t('rep.locations.source_of_truth_main')}</span>
                  </Button>
                </div>
              </div>

              <div className="mt-6">
                <SostoyanieOfisov />
              </div>

              {/* Сетка по числу офисов: один офис — на всю ширину, а не в треть. */}
              <div className={`grid grid-cols-1 gap-6 mt-6 ${
                officeList.length >= 3 ? 'md:grid-cols-2 lg:grid-cols-3' : officeList.length === 2 ? 'md:grid-cols-2' : ''
              }`}>
                {officeList.map((office) => (
                  <Card
                    key={office.kluch}
                    className="p-6 flex flex-col justify-between space-y-4"
                    style={{
                      borderColor: office.is_main ? 'var(--accent)' : 'var(--border)',
                      borderWidth: office.is_main ? '2px' : '1px'
                    }}
                  >
                    <div>
                      <div className="flex items-start justify-between">
                        <div>
<Badge
                            variant={office.is_main ? 'accent' : 'secondary'}
                            className="gap-1.5 font-bold mb-2"
                          >
                            {office.is_main && <Sparkles className="w-3 h-3 text-accent" />}
                            <span>{office.is_main ? t('rep.office.badge_main_canon_caps') : t('rep.office.badge_branch_caps')}</span>
                          </Badge>
                          <h3 className="text-lg font-serif text-text">{office.nazvanie}</h3>
                          <div className="text-xs text-text-muted mt-1.5 flex items-start gap-1.5">
                            <MapPin className={`w-4 h-4 shrink-0 mt-0.5 ${office.is_main ? 'text-accent' : 'text-text-muted'}`} />
                            <span className="font-medium text-text">{office.address}</span>
                          </div>
                          <div className="text-xs text-text font-medium mt-1.5">
                            {office.company_name} · {office.phone}
                          </div>
                          {/* 🔴 Описания филиалов были написаны ПО ИМЕНИ ГОРОДА в
                              вёрстке, включая описание несуществующего офиса. Что
                              за офис и как он работает — канон держателя, а не
                              разветвление по строке. */}
                          <p className="text-xs text-text-muted mt-2 leading-relaxed">
                            {office.is_main
                              ? t('rep.office.desc_main_canon')
                              : t('rep.office.desc_branch')}
                            {' '}{t('rep.office.hours_notice')}
                          </p>
                          <OfficeConnectionSteps
                            office={office}
                            gmbAuthStatus={gmbAuthStatus}
                            onCreateProfile={handleCreateProfileFromOffice}
                            onConnectGoogle={handleConnectGoogle}
                            isCreating={creatingProfileKluch === office.kluch}
                            t={t}
                          />
                        </div>
                      </div>

                      {/* 🔴 Три «показателя» офиса — Squad, Accuracy и Status
                          «Verified» — были литералами: ни состав роя, ни
                          точность NAP, ни проверенность записи отсюда не
                          измеряются. */}
                      <div className={`grid grid-cols-3 gap-2 pt-3 mt-3 border-t border-border text-center ${officeList.length === 1 ? 'max-w-xl' : ''}`}>
                        {['squad', 'accuracy', 'status'].map((podpis) => (
                          <div key={podpis} className="p-2 bg-white rounded-lg border border-border">
                            <div className="text-[10px] text-text-muted uppercase font-bold">{t(`rep.office.metric.${podpis}`)}</div>
                            <div className="text-sm font-bold text-text-muted mt-0.5">{NET_CHISLA}</div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {!office.profileId ? (
                      <div className="flex flex-wrap items-center gap-2 pt-3 border-t border-surface-sunken">
                        <button
                          onClick={() => handleCreateProfileFromOffice(office)}
                          disabled={creatingProfileKluch === office.kluch}
                          className="h-9 px-3 inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-xl bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50 transition-colors shadow-2xs cursor-pointer"
                        >
                          <Plus className="w-3.5 h-3.5 text-accent" />
                          <span>{creatingProfileKluch === office.kluch ? t('rep.office.creating_profile') : t('rep.office.btn_create_profile')}</span>
                        </button>
                        {!gmbAuthStatus.has_gmb_scope && (
                          <div className="inline-flex flex-col items-start gap-1">
                            <button
                              onClick={handleConnectGoogle}
                              className="h-9 px-3 inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-xl bg-surface-raised border border-border text-text hover:bg-surface transition-colors cursor-pointer shadow-2xs"
                            >
                              <span>{t('rep.office.btn_connect_google')}</span>
                            </button>
                            <span className="text-[10px] text-text-muted max-w-[320px]">
                              {t('rep.office.google_account_hint')}
                            </span>
                          </div>
                        )}
                        {!office.place_id && (
                          <span className="text-xs text-text-muted px-2.5 py-1.5 rounded-lg bg-surface-sunken">
                            {t('rep.office.step_no_place_id')}
                          </span>
                        )}
                      </div>
                    ) : (
                      <div className="flex flex-wrap items-center gap-2 pt-3 border-t border-surface-sunken">
                        <button
                          onClick={() => {
                            if (!office.profileId) return;
                            setSelectedGmbOffice({ ...office, id: office.profileId });
                            setIsGmbModalOpen(true);
                          }}
                          disabled={!office.profileId}
                          className={`h-9 px-3 inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-xl bg-accent-soft text-accent-ink border border-accent-border transition-colors shadow-2xs ${office.profileId ? 'hover:opacity-90 cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                          title={office.profileId ? t('rep.office.gmb_console_title') : t('rep.office.unlinked_profile_notice')}
                        >
                          <Sparkles className="w-3.5 h-3.5 text-accent" />
                          <span>GMB AI</span>
                        </button>
                        {office.gmb_url && (
                          <a
                            href={office.gmb_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="h-9 px-3 inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-xl bg-surface-raised border border-border text-text hover:bg-surface transition-colors cursor-pointer shadow-2xs"
                            title="Open Google Maps Listing"
                          >
                            <ExternalLink className="w-3.5 h-3.5 text-accent" />
                            <span>GMB</span>
                          </a>
                        )}
                        <button
                          onClick={() => office.profileId && onOpenSourceOfTruth && onOpenSourceOfTruth({ ...office, id: office.profileId })}
                          disabled={!office.profileId}
                          title={office.profileId ? t('rep.office.truth_source_title') : t('rep.office.unlinked_profile_notice')}
                          className={`flex-1 h-9 inline-flex items-center justify-center gap-2 text-xs font-semibold rounded-xl bg-surface-raised border border-border text-text transition-colors shadow-2xs ${office.profileId ? 'hover:bg-surface cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                        >
                          <FileText className="w-3.5 h-3.5 text-text-muted" />
                          <span>{t('rep.action.source_of_truth')}</span>
                        </button>
                        <button
                          onClick={() => office.profileId && onOpenAgentBattle && onOpenAgentBattle({ ...office, id: office.profileId })}
                          disabled={!office.profileId}
                          title={office.profileId ? t('rep.office.arena_title') : t('rep.office.unlinked_profile_notice')}
                          className={`flex-1 h-9 inline-flex items-center justify-center gap-2 text-xs font-semibold rounded-xl transition-colors shadow-xs ${!office.profileId ? 'opacity-50 cursor-not-allowed ' : 'cursor-pointer '}${
                            office.is_main
                              ? 'bg-primary text-primary-foreground hover:opacity-90'
                              : 'bg-accent-soft text-accent-ink border border-accent-border hover:opacity-90'
                          }`}
                        >
                          <Swords className="w-3.5 h-3.5 text-accent" />
                          <span>{t('rep.office.arena_title')}</span>
                        </button>
                        <button
                          onClick={() => office.profileId && onOpenAnalytics && onOpenAnalytics({ ...office, id: office.profileId })}
                          disabled={!office.profileId}
                          className={`h-9 px-3 inline-flex items-center justify-center text-xs font-semibold rounded-xl bg-surface-raised border border-border text-text transition-colors shadow-2xs ${office.profileId ? 'hover:bg-surface cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                          title={office.profileId ? t('rep.office.analytics_title') : t('rep.office.unlinked_profile_notice')}
                        >
                          <BarChart3 className="w-4 h-4 text-text-muted" />
                        </button>
                      </div>
                    )}
                  </Card>
                ))}
              </div>
            </Card>
          </div>
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 4: CITATIONS & DIRECTORIES                                      */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'citations' && (
          <div className="space-y-6">
            <DirectoriesTable tenant={tenant} />
            <CitationsWorklist tenant={tenant} />
          </div>
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 5: ПОСТЫ GOOGLE («ВЫШЛО ЗА СУТКИ»)                               */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'gmb_posts' && (
          <GmbPostsTab profileId={profiles[0]?.id} profiles={profiles} />
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 6: ПЛОЩАДКИ РОСТА (STAGE 3)                                     */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'opportunities' && (
          <GrowthOpportunitiesTab tenant={tenant} />
        )}

      </div>

      {/* GMB AI Command Center Modal */}
      <GmbCommandModal
        isOpen={isGmbModalOpen}
        onClose={() => setIsGmbModalOpen(false)}
        office={selectedGmbOffice}
      />

      {/* Полный аудит: окно показывает состояние ПРОГОНА НА СЕРВЕРЕ */}
      <FullAuditModal
        open={auditOpen}
        onClose={() => setAuditOpen(false)}
        onCompleted={() => zaprositPosledniy()}
      />
    </div>
  );
};

export default GrowthWorkspace;
